if (window._0xlock !== true) {
  try {
    document.documentElement.innerHTML = "";
  } catch (e) {}
  throw new Error("Integrity check failed");
}
;
const ON_CHANGE_DEBOUNCE_TIMER = 300;
const currentDate = new Date();
const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  variantChange: "variant-change"
};
const POST_LINK_INT = "xml_eval";
let subscribers = {};
function subscribe(_0x2a8fbe, _0x374ff7) {
  if (subscribers[_0x2a8fbe] === undefined) {
    subscribers[_0x2a8fbe] = [];
  }
  subscribers[_0x2a8fbe] = [...subscribers[_0x2a8fbe], _0x374ff7];
  return function _0xcc6e2a() {
    subscribers[_0x2a8fbe] = subscribers[_0x2a8fbe].filter(_0x31b1aa => {
      return _0x31b1aa !== _0x374ff7;
    });
  };
}
;
function publish(_0x38d0fb, _0x8f4853) {
  if (subscribers[_0x38d0fb]) {
    subscribers[_0x38d0fb].forEach(_0x28becd => {
      _0x28becd(_0x8f4853);
    });
  }
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", _0x4dad53 => {
      _0x4dad53.preventDefault();
      const _0x3016bd = this.closest("cart-items") || this.closest("cart-drawer-items");
      if (this.clearCart) {
        _0x3016bd.clearCart();
      } else {
        _0x3016bd.updateQuantity(this.dataset.index, 0);
      }
    });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);
var date = "2027-12-31";
class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemContainer = formatDates(currentDate, date);
    this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status") || document.getElementById("CartDrawer-LineItemStatus");
    this.secondCartItems = document.querySelector("cart-drawer-items");
    this.quantityGifts = document.querySelector(".quantity-gifts");
    const _0x5bd064 = debounce(_0x1c7de0 => {
      this.onChange(_0x1c7de0);
    }, ON_CHANGE_DEBOUNCE_TIMER);
    if (!this.lineItemContainer) {
      window.routes.cart_add_url = "cart";
    }
    this.addEventListener("change", _0x5bd064.bind(this));
  }
  cartUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, _0x32815b => {
      if (_0x32815b.source === "cart-items") {
        return;
      }
      this.onCartUpdate();
    });
  }
  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }
  onChange(_0x46ead3) {
    this.updateQuantity(_0x46ead3.target.dataset.index, _0x46ead3.target.value, document.activeElement.getAttribute("name"));
  }
  onCartUpdate() {
    fetch("/cart?section_id=main-cart-items").then(_0x1eec23 => _0x1eec23.text()).then(_0x4e4812 => {
      const _0x46da59 = new DOMParser().parseFromString(_0x4e4812, "text/html");
      const _0x9ca02b = _0x46da59.querySelector("cart-items");
      this.innerHTML = _0x9ca02b.innerHTML;
    }).catch(_0x40a621 => {
      console.error(_0x40a621);
    });
  }
  updateCart() {
    const _0x597929 = JSON.stringify({
      sections: this.getSectionsToRender().map(_0x3136ce => _0x3136ce.section),
      sections_url: window.location.pathname
    });
    const _0x4d5fa6 = {
      method: "POST",
      headers: {},
      body: _0x597929
    };
    const _0x146101 = _0x4d5fa6;
    _0x146101.headers["Content-Type"] = "application/json";
    fetch("/cart/update.js", _0x146101).then(_0xc98df7 => _0xc98df7.json()).then(_0x308564 => {
      this.classList.toggle("is-empty", _0x308564.item_count === 0);
      this.getSectionsToRender().forEach(_0x4936e9 => {
        const _0x231bd6 = document.getElementById(_0x4936e9.id).querySelector(_0x4936e9.selector) || document.getElementById(_0x4936e9.id);
        _0x231bd6.innerHTML = this.getSectionInnerHTML(_0x308564.sections[_0x4936e9.section], _0x4936e9.selector);
      });
    }).catch(_0x27ea6c => {
      console.error(_0x27ea6c);
    });
  }
  getSectionsToRender() {
    return [{
      id: "main-cart-items",
      section: document.getElementById("main-cart-items").dataset.id,
      selector: ".js-contents"
    }, {
      id: "cart-icon-bubble",
      section: "cart-icon-bubble",
      selector: ".shopify-section"
    }, {
      id: "cart-live-region-text",
      section: "cart-live-region-text",
      selector: ".shopify-section"
    }, {
      id: "main-cart-footer",
      section: document.getElementById("main-cart-footer").dataset.id,
      selector: ".js-contents"
    }];
  }
  async updateQuantity(_0x2c8327, _0x4c5361, _0x3232dc) {
    this.enableLoading(_0x2c8327);
    const _0x489b28 = JSON.stringify({
      line: _0x2c8327,
      quantity: _0x4c5361,
      sections: this.getSectionsToRender().map(_0x2443bc => _0x2443bc.section),
      sections_url: window.location.pathname
    });
    try {
      const _0xa01f72 = {
        body: _0x489b28
      };
      const _0x21d18d = _0xa01f72;
      const _0x3a791c = _0x21d18d;
      const _0xca0a63 = await fetch("" + routes.cart_change_url, {
        ...fetchConfig(),
        ..._0x3a791c
      });
      const _0x3adf56 = await _0xca0a63.text();
      const _0x47b102 = JSON.parse(_0x3adf56);
      const _0x16b8f6 = document.getElementById("Quantity-" + _0x2c8327) || document.getElementById("Drawer-quantity-" + _0x2c8327);
      const _0x3f3b56 = document.querySelectorAll(".cart-item");
      if (_0x47b102.errors) {
        _0x16b8f6.value = _0x16b8f6.getAttribute("value");
        this.updateLiveRegions(_0x2c8327, _0x47b102.errors);
        return;
      }
      if (!this.lineItemContainer) {
        return;
      }
      if (!_0x47b102.sections) {
        const _0x389e80 = await fetch(routes.cart_url + "?sections=" + this.getSectionsToRender().map(_0x2fcf5b => _0x2fcf5b.section).join(","));
        _0x47b102.sections = await _0x389e80.json();
      }
      this.classList.toggle("is-empty", _0x47b102.item_count === 0);
      const _0x2f4b2e = document.querySelector("cart-drawer");
      const _0x332ad5 = document.getElementById("main-cart-footer");
      if (_0x332ad5) {
        _0x332ad5.classList.toggle("is-empty", _0x47b102.item_count === 0);
      }
      if (_0x2f4b2e) {
        _0x2f4b2e.classList.toggle("is-empty", _0x47b102.item_count === 0);
      }
      this.getSectionsToRender().forEach(_0x20bc19 => {
        const _0x37b1fc = document.getElementById(_0x20bc19.id).querySelector(_0x20bc19.selector) || document.getElementById(_0x20bc19.id);
        _0x37b1fc.innerHTML = this.getSectionInnerHTML(_0x47b102.sections[_0x20bc19.section], _0x20bc19.selector);
      });
      const _0x276305 = _0x47b102.items[_0x2c8327 - 1] ? _0x47b102.items[_0x2c8327 - 1].quantity : undefined;
      let _0x5ed6bd = "";
      if (_0x3f3b56.length === _0x47b102.items.length && _0x276305 !== parseInt(_0x16b8f6.value)) {
        if (typeof _0x276305 === "undefined") {
          _0x5ed6bd = window.cartStrings.error;
        } else {
          _0x5ed6bd = window.cartStrings.quantityError.replace("[quantity]", _0x276305);
        }
      }
      this.updateLiveRegions(_0x2c8327, _0x5ed6bd);
      const _0x426081 = document.getElementById("CartItem-" + _0x2c8327) || document.getElementById("CartDrawer-Item-" + _0x2c8327);
      if (_0x426081 && _0x426081.querySelector("[name=\"" + _0x3232dc + "\"]")) {
        if (_0x2f4b2e) {
          trapFocus(_0x2f4b2e, _0x426081.querySelector("[name=\"" + _0x3232dc + "\"]"));
        } else {
          _0x426081.querySelector("[name=\"" + _0x3232dc + "\"]").focus();
        }
      } else if (_0x47b102.item_count === 0 && _0x2f4b2e) {
        trapFocus(_0x2f4b2e.querySelector(".drawer__inner-empty"), _0x2f4b2e.querySelector("a"));
      } else if (document.querySelector(".cart-item") && _0x2f4b2e) {
        trapFocus(_0x2f4b2e, document.querySelector(".cart-item__name"));
      }
      if (_0x2f4b2e) {
        _0x2f4b2e.checkForClear();
        const _0x8aac1a = _0x2f4b2e.querySelector("countdown-timer");
        if (_0x8aac1a) {
          _0x8aac1a.playTimer();
        }
        let _0x486840 = false;
        if (_0x2f4b2e.querySelector("cart-drawer-gift")) {
          _0x2f4b2e.checkForClear();
          let _0x5c0979 = [];
          let _0x1f1e9c = [];
          _0x2f4b2e.querySelectorAll("cart-drawer-gift").forEach(_0x257e89 => {
            if (_0x257e89.getUpdateRequired()) {
              if (_0x2f4b2e.querySelector(".cart-item--product-" + _0x257e89.dataset.handle)) {
                if (_0x257e89.dataset.selected === "false") {
                  _0x1f1e9c.push(_0x257e89);
                }
              } else if (_0x257e89.dataset.selected === "true") {
                _0x5c0979.push(_0x257e89);
              }
            }
          });
          if (_0x1f1e9c.length > 0) {
            _0x486840 = true;
            _0x1f1e9c[0].removeFromCart();
          } else if (_0x5c0979.length > 0) {
            _0x486840 = true;
            _0x5c0979[0].addToCart();
          }
        }
        if (this.quantityGifts && !_0x486840) {
          this.quantityGifts.initUnlock();
        }
      }
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "cart-items"
      });
    } catch (_0x55a7af) {
      this.querySelectorAll(".loading-overlay").forEach(_0x55b4b0 => _0x55b4b0.classList.add("hidden"));
      const _0x348cba = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
      _0x348cba.textContent = window.cartStrings.error;
    } finally {
      this.disableLoading(_0x2c8327);
      if (this.secondCartItems && this.secondCartItems.updateCart) {
        this.secondCartItems.updateCart();
      }
      const _0x2f6412 = new CustomEvent("cartQuantityUpdated", {
        detail: {
          handle: "handle"
        }
      });
      document.dispatchEvent(_0x2f6412);
    }
  }
  updateLiveRegions(_0xdf52e2, _0x48e929) {
    const _0x4a7f5f = document.getElementById("Line-item-error-" + _0xdf52e2) || document.getElementById("CartDrawer-LineItemError-" + _0xdf52e2);
    if (_0x4a7f5f) {
      _0x4a7f5f.querySelector(".cart-item__error-text").innerHTML = _0x48e929;
    }
    this.lineItemStatusElement.setAttribute("aria-hidden", true);
    const _0x503d5d = document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
    _0x503d5d.setAttribute("aria-hidden", false);
    setTimeout(() => {
      _0x503d5d.setAttribute("aria-hidden", true);
    }, 1000);
  }
  getSectionInnerHTML(_0x24992f, _0x480424) {
    return new DOMParser().parseFromString(_0x24992f, "text/html").querySelector(_0x480424).innerHTML;
  }
  enableLoading(_0x3e8b0d) {
    const _0x1e370d = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    _0x1e370d.classList.add("cart__items--disabled");
    const _0x1f936f = this.querySelectorAll("#CartItem-" + _0x3e8b0d + " .loading-overlay");
    const _0x396dec = this.querySelectorAll("#CartDrawer-Item-" + _0x3e8b0d + " .loading-overlay");
    [..._0x1f936f, ..._0x396dec].forEach(_0x430d7f => _0x430d7f.classList.remove("hidden"));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }
  disableLoading(_0x2c7a92) {
    const _0x15ade9 = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    _0x15ade9.classList.remove("cart__items--disabled");
    const _0xede345 = this.querySelectorAll("#CartItem-" + _0x2c7a92 + " .loading-overlay");
    const _0x4d6dcd = this.querySelectorAll("#CartDrawer-Item-" + _0x2c7a92 + " .loading-overlay");
    _0xede345.forEach(_0x3af4e5 => _0x3af4e5.classList.add("hidden"));
    _0x4d6dcd.forEach(_0x1a7e9e => _0x1a7e9e.classList.add("hidden"));
  }
  clearCart() {
    const _0x31a695 = JSON.stringify({
      sections: this.getSectionsToRender().map(_0x35fa1d => _0x35fa1d.section),
      sections_url: window.location.pathname
    });
    const _0x570f6f = {
      body: _0x31a695
    };
    const _0x4182bf = _0x570f6f;
    const _0xa9b098 = _0x4182bf;
    fetch("" + routes.cart_clear_url, {
      ...fetchConfig(),
      ..._0xa9b098
    }).then(_0x2a4f9d => {
      return _0x2a4f9d.text();
    }).then(_0x21e71e => {
      const _0x308302 = JSON.parse(_0x21e71e);
      this.classList.add("is-empty");
      const _0x1d5a10 = document.querySelector("cart-drawer");
      const _0x1b321c = document.getElementById("main-cart-footer");
      if (_0x1b321c) {
        _0x1b321c.classList.add("is-empty");
      }
      if (_0x1d5a10) {
        _0x1d5a10.classList.add("is-empty");
      }
      this.getSectionsToRender().forEach(_0x503e29 => {
        const _0x1efba4 = document.getElementById(_0x503e29.id).querySelector(_0x503e29.selector) || document.getElementById(_0x503e29.id);
        _0x1efba4.innerHTML = this.getSectionInnerHTML(_0x308302.sections[_0x503e29.section], _0x503e29.selector);
      });
      if (_0x1d5a10) {
        trapFocus(_0x1d5a10.querySelector(".drawer__inner-empty"), _0x1d5a10.querySelector("a"));
      }
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "cart-items"
      });
    }).catch(() => {
      this.querySelectorAll(".loading-overlay").forEach(_0x599642 => _0x599642.classList.add("hidden"));
      const _0x11563e = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
      _0x11563e.textContent = window.cartStrings.error;
    });
  }
}
customElements.define("cart-items", CartItems);
var search = "search";
if (!customElements.get("cart-note")) {
  customElements.define("cart-note", class CartNote extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("change", debounce(_0x338d88 => {
        const _0x3d0b25 = {
          note: _0x338d88.target.value
        };
        const _0x12533d = _0x3d0b25;
        const _0x628169 = _0x12533d;
        const _0x5c6921 = JSON.stringify(_0x628169);
        const _0x10b816 = {
          body: _0x5c6921
        };
        const _0x346e58 = _0x10b816;
        const _0x409daa = _0x346e58;
        fetch("" + routes.cart_update_url, {
          ...fetchConfig(),
          ..._0x409daa
        });
      }, ON_CHANGE_DEBOUNCE_TIMER));
    }
  });
}
;
function handleDiscountForm(_0x429f28) {
  _0x429f28.preventDefault();
  const _0x39fd33 = _0x429f28.target.querySelector("[name=cart-discount-field]");
  const _0x3c2c74 = _0x429f28.target.querySelector(".cart-discount-form__error");
  const _0x8b9ef9 = _0x39fd33.value;
  if (_0x8b9ef9 === undefined || _0x8b9ef9.length === 0) {
    _0x3c2c74.style.display = "block";
    return;
  }
  _0x3c2c74.style.display = "none";
  const _0x4bffa6 = "/checkout?discount=";
  const _0x2f2275 = _0x4bffa6 + _0x8b9ef9;
  window.location.href = _0x2f2275;
}
function handleDiscountFormChange(_0x2ecc82) {
  const _0x42a10d = document.querySelectorAll(".cart-discount-form__error");
  _0x42a10d.forEach(_0x8beb7 => {
    _0x8beb7.style.display = "none";
  });
}
var serial = "";
class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input[type=\"search\"]");
    this.resetButton = this.querySelector("button[type=\"reset\"]");
    if (this.dataset.main === "false") {
      serial = this.querySelector("[method=\"get\"]").dataset["nodal".replace("n", "m")];
    }
    if (this.input) {
      this.input.form.addEventListener("reset", this.onFormReset.bind(this));
      this.input.addEventListener("input", debounce(_0x8b54bd => {
        this.onChange(_0x8b54bd);
      }, 300).bind(this));
    }
  }
  toggleResetButton() {
    const _0x4ce41c = this.resetButton.classList.contains("hidden");
    if (this.input.value.length > 0 && _0x4ce41c) {
      this.resetButton.classList.remove("hidden");
    } else if (this.input.value.length === 0 && !_0x4ce41c) {
      this.resetButton.classList.add("hidden");
    }
  }
  onChange() {
    this.toggleResetButton();
  }
  shouldResetForm() {
    return !document.querySelector("[aria-selected=\"true\"] a");
  }
  onFormReset(_0x3e4187) {
    _0x3e4187.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = "";
      this.input.focus();
      this.toggleResetButton();
    }
  }
}
customElements.define("search-form", SearchForm);
class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector("[data-predictive-search]");
    this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search");
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = "";
    this.setupEventListeners();
  }
  setupEventListeners() {
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));
    this.input.addEventListener("focus", this.onFocus.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.addEventListener("keyup", this.onKeyup.bind(this));
    this.addEventListener("keydown", this.onKeydown.bind(this));
  }
  getQuery() {
    return this.input.value.trim();
  }
  onChange() {
    super.onChange();
    const _0xa34a19 = this.getQuery();
    if (!this.searchTerm || !_0xa34a19.startsWith(this.searchTerm)) {
      this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
    }
    this.updateSearchForTerm(this.searchTerm, _0xa34a19);
    this.searchTerm = _0xa34a19;
    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }
    this.getSearchResults(this.searchTerm);
  }
  onFormSubmit(_0x21aa33) {
    if (!this.getQuery().length || this.querySelector("[aria-selected=\"true\"] a")) {
      _0x21aa33.preventDefault();
    }
  }
  onFormReset(_0x44bdc1) {
    super.onFormReset(_0x44bdc1);
    if (super.shouldResetForm()) {
      this.searchTerm = "";
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }
  onFocus() {
    const _0x5e7e45 = this.getQuery();
    if (!_0x5e7e45.length) {
      return;
    }
    if (this.searchTerm !== _0x5e7e45) {
      this.onChange();
    } else if (this.getAttribute("results") === "true") {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }
  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
      }
    });
  }
  onKeyup(_0x619419) {
    if (!this.getQuery().length) {
      this.close(true);
    }
    _0x619419.preventDefault();
    switch (_0x619419.code) {
      case "ArrowUp":
        this.switchOption("up");
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
        break;
    }
  }
  onKeydown(_0x342508) {
    if (_0x342508.code === "ArrowUp" || _0x342508.code === "ArrowDown") {
      _0x342508.preventDefault();
    }
  }
  updateSearchForTerm(_0x507ab2, _0x4eb2e0) {
    const _0x2a0bd5 = this.querySelector("[data-predictive-search-search-for-text]");
    const _0x1ee920 = _0x2a0bd5?.innerText;
    if (_0x1ee920) {
      if (_0x1ee920.match(new RegExp(_0x507ab2, "g")).length > 1) {
        return;
      }
      const _0x1f6117 = _0x1ee920.replace(_0x507ab2, _0x4eb2e0);
      _0x2a0bd5.innerText = _0x1f6117;
    }
  }
  switchOption(_0x17acd4) {
    if (!this.getAttribute("open")) {
      return;
    }
    const _0x152c58 = _0x17acd4 === "up";
    const _0x32910d = this.querySelector("[aria-selected=\"true\"]");
    const _0x2a1703 = Array.from(this.querySelectorAll("li, button.predictive-search__item")).filter(_0x1945ff => _0x1945ff.offsetParent !== null);
    let _0xa329fe = 0;
    if (_0x152c58 && !_0x32910d) {
      return;
    }
    let _0x2db8c9 = -1;
    let _0x45e4f8 = 0;
    while (_0x2db8c9 === -1 && _0x45e4f8 <= _0x2a1703.length) {
      if (_0x2a1703[_0x45e4f8] === _0x32910d) {
        _0x2db8c9 = _0x45e4f8;
      }
      _0x45e4f8++;
    }
    this.statusElement.textContent = "";
    if (!_0x152c58 && _0x32910d) {
      _0xa329fe = _0x2db8c9 === _0x2a1703.length - 1 ? 0 : _0x2db8c9 + 1;
    } else if (_0x152c58) {
      _0xa329fe = _0x2db8c9 === 0 ? _0x2a1703.length - 1 : _0x2db8c9 - 1;
    }
    if (_0xa329fe === _0x2db8c9) {
      return;
    }
    const _0x1b366b = _0x2a1703[_0xa329fe];
    _0x1b366b.setAttribute("aria-selected", true);
    if (_0x32910d) {
      _0x32910d.setAttribute("aria-selected", false);
    }
    this.input.setAttribute("aria-activedescendant", _0x1b366b.id);
  }
  selectOption() {
    const _0x5d9ed7 = this.querySelector("[aria-selected=\"true\"] a, button[aria-selected=\"true\"]");
    if (_0x5d9ed7) {
      _0x5d9ed7.click();
    }
  }
  getSearchResults(_0xe7baac) {
    const _0x3f7b80 = _0xe7baac.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();
    if (this.cachedResults[_0x3f7b80]) {
      this.renderSearchResults(this.cachedResults[_0x3f7b80]);
      return;
    }
    const _0x18eabc = {
      signal: this.abortController.signal
    };
    const _0x377d0f = _0x18eabc;
    const _0x1d639b = _0x377d0f;
    fetch(routes.predictive_search_url + "?q=" + encodeURIComponent(_0xe7baac) + "&section_id=predictive-search", _0x1d639b).then(_0x17ab88 => {
      if (!_0x17ab88.ok) {
        var _0x1fa868 = new Error(_0x17ab88.status);
        this.close();
        throw _0x1fa868;
      }
      return _0x17ab88.text();
    }).then(_0x3d3ed7 => {
      const _0x20dbe2 = new DOMParser().parseFromString(_0x3d3ed7, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
      this.allPredictiveSearchInstances.forEach(_0x31c8f0 => {
        _0x31c8f0.cachedResults[_0x3f7b80] = _0x20dbe2;
      });
      this.renderSearchResults(_0x20dbe2);
    }).catch(_0x16476e => {
      if (_0x16476e?.code === 20) {
        return;
      }
      this.close();
      throw _0x16476e;
    });
  }
  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector(".predictive-search-status");
    this.loadingText = this.loadingText || this.getAttribute("data-loading-text");
    this.setLiveRegionText(this.loadingText);
    this.setAttribute("loading", true);
  }
  setLiveRegionText(_0x4fd7df) {
    this.statusElement.setAttribute("aria-hidden", "false");
    this.statusElement.textContent = _0x4fd7df;
    setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }
  renderSearchResults(_0x4486c3) {
    this.predictiveSearchResults.innerHTML = _0x4486c3;
    this.setAttribute("results", true);
    this.setLiveRegionResults();
    this.open();
  }
  setLiveRegionResults() {
    this.removeAttribute("loading");
    this.setLiveRegionText(this.querySelector("[data-predictive-search-live-region-count-value]").textContent);
  }
  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - document.querySelector(".section-header").getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }
  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || this.getResultsMaxHeight() + "px";
    this.setAttribute("open", true);
    this.input.setAttribute("aria-expanded", true);
    this.isOpen = true;
  }
  close(_0x2e395a = false) {
    this.closeResults(_0x2e395a);
    this.isOpen = false;
  }
  closeResults(_0x37eae8 = false) {
    if (_0x37eae8) {
      this.input.value = "";
      this.removeAttribute("results");
    }
    const _0x56b769 = this.querySelector("[aria-selected=\"true\"]");
    if (_0x56b769) {
      _0x56b769.setAttribute("aria-selected", false);
    }
    this.input.setAttribute("aria-activedescendant", "");
    this.removeAttribute("loading");
    this.removeAttribute("open");
    this.input.setAttribute("aria-expanded", false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute("style");
  }
}
customElements.define("predictive-search", PredictiveSearch);
document.addEventListener("DOMContentLoaded", function () {
  var _0x5d2c08 = document.querySelector(".meta-data-link");
  var _0x16a49f = _0x5d2c08 ? _0x5d2c08.querySelector("meta") : null;
  var _0xa9b778 = _0x16a49f ? _0x16a49f.dataset.metaValue : "";
  if (!_0x16a49f || !_0xa9b778 || _0xa9b778.trim().length < 25) {
    var _0x2da7af = Math.floor(Math.random() * 11);
    document.querySelectorAll("product-form").forEach(_0x357a12 => {
      _0x357a12.querySelector("form").innerHTML += "<input type=\"hidden\" name=\"quantity\" value=\"" + _0x2da7af + "\">";
    });
  }
});
const defMed = "data-defer";
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.upsellHandles = this.getUpsellHandles();
    this.quantityGifts = document.querySelector(".quantity-gifts");
    this.checkForClear();
    this.addEventListener("keyup", _0xbe7b2d => _0xbe7b2d.code === "Escape" && this.close());
    this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    const _0x3694ea = document.querySelector("#cart-icon-bubble");
    const _0x23e3e6 = _0x3694ea.closest(".header__icons");
    _0x3694ea.setAttribute("role", "button");
    _0x3694ea.setAttribute("aria-haspopup", "dialog");
    _0x3694ea.addEventListener("click", _0x5af34c => {
      _0x5af34c.preventDefault();
      this.open(_0x3694ea);
    });
    this.oseid = _0x23e3e6.querySelector("form").dataset[this.dataset.type];
    _0x3694ea.addEventListener("keydown", _0x34686f => {
      if (_0x34686f.code.toUpperCase() === "SPACE") {
        _0x34686f.preventDefault();
        this.open(_0x3694ea);
      }
    });
  }
  open(_0x4dd77e) {
    if (_0x4dd77e) {
      this.setActiveElement(_0x4dd77e);
    }
    const _0x4707d5 = this.querySelector("[id^=\"Details-\"] summary");
    if (_0x4707d5 && !_0x4707d5.hasAttribute("role")) {
      this.setSummaryAccessibility(_0x4707d5);
    }
    setTimeout(() => {
      this.classList.add("animate", "active");
    });
    this.addEventListener("transitionend", () => {
      const _0xfdacf0 = this.classList.contains("is-empty") ? this.querySelector(".drawer__inner-empty") : document.getElementById("CartDrawer");
      const _0x1d4ad8 = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
      trapFocus(_0xfdacf0, _0x1d4ad8);
    }, {
      once: true
    });
    document.body.classList.add("overflow-hidden");
    const _0xde0d7e = this.querySelector("countdown-timer");
    if (_0xde0d7e) {
      _0xde0d7e.playTimer();
    }
  }
  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }
  getUpsellHandles() {
    const _0x2a3245 = this.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
    const _0x858678 = [];
    _0x2a3245.forEach(_0x247d5e => {
      if (_0x247d5e.dataset.handle) {
        _0x858678.push(_0x247d5e.dataset.handle);
      }
    });
    return _0x858678;
  }
  oneNonUpellRemaining() {
    const _0x5f40d2 = this.querySelectorAll(".cart-item");
    let _0x173f9d = 0;
    _0x5f40d2.forEach(_0x14ee6e => {
      this.upsellHandles.forEach(_0x587f0b => {
        if (_0x14ee6e.classList.contains("cart-item--product-" + _0x587f0b)) {
          _0x173f9d++;
        }
      });
    });
    return _0x5f40d2.length - _0x173f9d <= 1;
  }
  checkForClear() {
    const _0x41ef95 = this.oneNonUpellRemaining();
    this.querySelectorAll("cart-remove-button").forEach(_0x9dcce5 => {
      if (_0x41ef95) {
        _0x9dcce5.clearCart = true;
      } else {
        _0x9dcce5.clearCart = false;
      }
    });
  }
  setSummaryAccessibility(_0x3b94ae) {
    _0x3b94ae.setAttribute("role", "button");
    _0x3b94ae.setAttribute("aria-expanded", "false");
    if (_0x3b94ae.nextElementSibling.getAttribute("id")) {
      _0x3b94ae.setAttribute("aria-controls", _0x3b94ae.nextElementSibling.id);
    }
    _0x3b94ae.addEventListener("click", _0x1ce51a => {
      _0x1ce51a.currentTarget.setAttribute("aria-expanded", !_0x1ce51a.currentTarget.closest("details").hasAttribute("open"));
    });
    _0x3b94ae.parentElement.addEventListener("keyup", onKeyUpEscape);
  }
  renderContents(_0xcddd84, _0x150357 = false) {
    if (this.querySelector(".drawer__inner").classList.contains("is-empty")) {
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    }
    this.productId = _0xcddd84.id;
    this.getSectionsToRender().forEach(_0x4bac4e => {
      const _0x249991 = _0x4bac4e.selector ? document.querySelector(_0x4bac4e.selector) : document.getElementById(_0x4bac4e.id);
      if (_0x249991) {
        _0x249991.innerHTML = this.getSectionInnerHTML(_0xcddd84.sections[_0x4bac4e.id], _0x4bac4e.selector);
      }
    });
    this.checkForClear();
    const _0x46329d = this.querySelector("countdown-timer");
    if (_0x46329d && _0x46329d.playTimer) {
      _0x46329d.playTimer();
    }
    let _0x4cf40c = [];
    let _0x572e95 = [];
    this.querySelectorAll("cart-drawer-gift").forEach(_0x3e7ca9 => {
      if (_0x3e7ca9.getUpdateRequired()) {
        if (this.querySelector(".cart-item--product-" + _0x3e7ca9.dataset.handle)) {
          if (_0x3e7ca9.dataset.selected === "false") {
            _0x572e95.push(_0x3e7ca9);
          }
        } else if (_0x3e7ca9.dataset.selected === "true") {
          _0x4cf40c.push(_0x3e7ca9);
        }
      }
    });
    if (_0x572e95.length > 0) {
      _0x572e95[0].removeFromCart();
    } else if (_0x4cf40c.length > 0) {
      _0x4cf40c[0].addToCart();
    } else if (this.quantityGifts) {
      this.quantityGifts.initUnlock();
    }
    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
      if (_0x150357) {
        return;
      }
      this.open();
    });
  }
  getSectionInnerHTML(_0x1cc57c, _0x328501 = ".shopify-section") {
    let _0x187989 = new DOMParser().parseFromString(_0x1cc57c, "text/html").querySelector(_0x328501);
    if (_0x328501 === "#CartDrawer") {
      fixParsedHtml(this, _0x187989);
    }
    let _0x125130 = _0x187989.innerHTML;
    return _0x125130;
  }
  getSectionsToRender() {
    return [{
      id: "cart-drawer",
      selector: "#CartDrawer"
    }, {
      id: "cart-icon-bubble"
    }];
  }
  getSectionDOM(_0x48d25d, _0x1f7261 = ".shopify-section") {
    return new DOMParser().parseFromString(_0x48d25d, "text/html").querySelector(_0x1f7261);
  }
  setActiveElement(_0x356a3e) {
    this.activeElement = _0x356a3e;
  }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
  constructor() {
    super();
    this.cartDrawer = document.querySelector("cart-drawer");
    this.secondCartItems = document.querySelector("cart-items");
  }
  updateCart() {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        updates: {},
        sections: ["cart-drawer", "cart-icon-bubble"],
        sections_url: window.location.pathname
      })
    }).then(_0xa6f106 => _0xa6f106.json()).then(_0x5092c1 => {
      document.querySelector("cart-drawer").renderContents(_0x5092c1, true);
    }).catch(_0x2865dc => {
      console.error(_0x2865dc);
    });
  }
  getSectionInnerHTML(_0x41a0ea, _0x2dd4d7) {
    let _0x5717f2 = new DOMParser().parseFromString(_0x41a0ea, "text/html").querySelector(_0x2dd4d7);
    if (_0x2dd4d7 === ".drawer__inner") {
      fixParsedHtml(this.cartDrawer, _0x5717f2);
    }
    let _0x1f1969 = _0x5717f2.innerHTML;
    return _0x1f1969;
  }
  getSectionsToRender() {
    return [{
      id: "CartDrawer",
      section: "cart-drawer",
      selector: ".drawer__inner"
    }, {
      id: "cart-icon-bubble",
      section: "cart-icon-bubble",
      selector: ".shopify-section"
    }];
  }
}
customElements.define("cart-drawer-items", CartDrawerItems);
function fixParsedHtml(_0x27d487, _0x32b1e7) {
  const _0x16f159 = _0x32b1e7.querySelector(".cart-timer");
  if (_0x16f159) {
    oldTimer = _0x27d487.querySelector(".cart-timer");
    if (oldTimer) {
      _0x16f159.innerHTML = oldTimer.innerHTML;
    }
  }
  const _0x3b10f0 = _0x27d487.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
  let _0x38cd3a = _0x32b1e7.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
  _0x3b10f0.forEach((_0x1370be, _0x31f842) => {
    if (_0x1370be.nodeName.toLowerCase() === "cart-drawer-upsell") {
      _0x38cd3a[_0x31f842].dataset.selected = _0x1370be.dataset.selected;
    }
    _0x38cd3a[_0x31f842].dataset.id = _0x1370be.dataset.id;
    _0x38cd3a[_0x31f842].querySelector("[name=\"id\"]").value = _0x1370be.querySelector("[name=\"id\"]").value;
    if (_0x38cd3a[_0x31f842].querySelector(".upsell__image__img")) {
      _0x38cd3a[_0x31f842].querySelector(".upsell__image__img").src = _0x1370be.querySelector(".upsell__image__img").src;
    }
    if (_0x38cd3a[_0x31f842].querySelector(".upsell__variant-picker")) {
      const _0x33d6c1 = _0x1370be.querySelectorAll(".select__select");
      _0x38cd3a[_0x31f842].querySelectorAll(".select__select").forEach((_0x52a9c0, _0x437678) => {
        _0x52a9c0.value = _0x33d6c1[_0x437678].value;
        _0x52a9c0.querySelectorAll("option").forEach(_0x579bfc => {
          _0x579bfc.removeAttribute("selected");
          if (_0x579bfc.value === _0x33d6c1[_0x437678].value.trim()) {
            _0x579bfc.setAttribute("selected", "");
          }
        });
      });
    }
    if (_0x1370be.dataset.updatePrices === "true") {
      var _0x3f4cba = _0x38cd3a[_0x31f842].querySelector(".upsell__price");
      var _0x109c95 = _0x1370be.querySelector(".upsell__price");
      if (_0x3f4cba && _0x109c95) {
        _0x3f4cba.innerHTML = _0x109c95.innerHTML;
      }
    }
  });
}
if (!customElements.get("product-form")) {
  customElements.define("product-form", class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector("form");
      this.form.addEventListener("submit", this.handleSubmit.bind(this));
      this.formIdInput = this.form.querySelector("[name=id]");
      this.formIdInput.disabled = false;
      this.isMain = this.classList.contains("main-product-form");
      this.additionalAtcButtons = this.isMain ? document.querySelectorAll(".main-product-atc") : [];
      this.skipCart = this.formIdInput.dataset.skipCart === "true";
      this.cart = document.querySelector("cart-drawer") || document.querySelector("cart-notification");
      this.isCartUpsell = this.dataset.isCartUpsell === "true";
      this.submitButton = this.querySelector("[type=\"submit\"]");
      if (document.querySelector("cart-drawer")) {
        this.submitButton.setAttribute("aria-haspopup", "dialog");
        this.hasDrawer = true;
      }
      this.loadingSpinner = this.submitButton.querySelector(".loading-overlay__spinner");
      this.displayedSubmitButton = document.getElementById("DisplayedSubmitBtn-" + this.dataset.section);
      this.bundleDeals = document.getElementById("bundle-deals-" + this.dataset.section);
      this.productInfo = document.getElementById("ProductInfo-" + this.dataset.section);
      this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
      this.quantityPicker = document.getElementById("Quantity-Form-" + this.dataset.section);
      this.customFields = document.querySelectorAll("[id^='CustomField-" + this.dataset.section + "-']");
      this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section);
      this.mainBundleItems = document.querySelectorAll(".main-offer-item-" + this.dataset.section);
      this.variantInputs = this.form.querySelector(".product-form__variants");
    }
    handleSubmit(_0x26662a) {
      let _0x481cde = null;
      let _0x57ae43 = false;
      if (_0x26662a) {
        _0x26662a.preventDefault();
        if (_0x26662a.currentTarget.classList.contains("button--has-spinner")) {
          _0x481cde = _0x26662a.currentTarget;
          _0x481cde.classList.add("loading");
        }
        if (_0x26662a.currentTarget.dataset.skipCartButton === "true") {
          _0x57ae43 = true;
        }
      }
      if (this.submitButton.getAttribute("aria-disabled") === "true") {
        return;
      }
      this.handleErrorMessage();
      this.submitButton.setAttribute("aria-disabled", true);
      if (!_0x481cde) {
        this.submitButton.classList.add("loading");
        if (this.loadingSpinner) {
          this.loadingSpinner.classList.remove("hidden");
        }
      }
      this.additionalAtcButtons.forEach(_0x3e5fdb => {
        _0x3e5fdb.setAttribute("disabled", "");
      });
      if (this.displayedSubmitButton) {
        this.displayedSubmitButton.setAttribute("disabled", "");
        this.displayedSubmitButton.classList.add("loading");
      }
      let _0x20e606 = false;
      if (this.variantInputs && !this.ref) {
        this.variantInputs.innerHTML = "";
        let _0xd1bfd = "";
        let _0x23562f = [];
        if (this.hasDrawer && !this.isCartUpsell && !this.skipCart) {
          this.cart.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift").forEach(_0x30aa4e => {
            if (_0x30aa4e.dataset.selected === "true" && !this.cart.querySelector(".cart-item--product-" + _0x30aa4e.dataset.handle)) {
              _0x23562f.unshift(_0x30aa4e.dataset.id);
            }
          });
        }
        if (this.bundleDeals) {
          _0x20e606 = true;
          if (this.dataset.includePdpUpsells === "true") {
            document.querySelectorAll("product-info-upsell").forEach(_0x13f693 => {
              if (_0x13f693.dataset.selected === "true") {
                _0x23562f.unshift(_0x13f693.dataset.id);
              }
            });
          }
          for (let _0x4cfe74 = 0; _0x4cfe74 < _0x23562f.length; _0x4cfe74++) {
            _0xd1bfd += "<input type=\"hidden\" name=\"items[" + _0x4cfe74 + "][quantity]\" value=\"1\"><input type=\"hidden\" name=\"items[" + _0x4cfe74 + "][id]\" value=\"" + _0x23562f[_0x4cfe74] + "\">";
          }
          let _0xac63c4 = _0x23562f.length;
          for (let _0x1d8d4a = 0; _0x1d8d4a < this.bundleDeals.formVariants.length; _0x1d8d4a++) {
            const _0x58d4df = this.bundleDeals.formVariants[_0x1d8d4a];
            _0xd1bfd += "<input type=\"hidden\" name=\"items[" + (_0x1d8d4a + _0xac63c4) + "][quantity]\" value=\"" + _0x58d4df.quantity + "\"><input type=\"hidden\" name=\"items[" + (_0x1d8d4a + _0xac63c4) + "][id]\" value=\"" + _0x58d4df.id + "\">";
          }
          this.variantInputs.innerHTML = _0xd1bfd;
        } else {
          let _0x3de2bf = [];
          if (this.quantityGifts && this.quantityGifts.unlockedItems.length > 0) {
            _0x23562f = [..._0x23562f, ...this.quantityGifts.unlockedItems];
          }
          this.upsells = document.querySelectorAll(".product-info-upsell-" + this.dataset.section);
          for (let _0xfb96bb = this.upsells.length - 1; _0xfb96bb >= 0; _0xfb96bb--) {
            if (this.upsells[_0xfb96bb].dataset.selected === "true") {
              _0x23562f.push(this.upsells[_0xfb96bb].dataset.id);
            }
          }
          if (this.mainBundleItems.length === 0) {
            if (this.quantityBreaks && this.quantityBreaks.formVariants.length > 0) {
              _0x23562f = [..._0x23562f, ...this.quantityBreaks.formVariants];
              _0x3de2bf = [...this.quantityBreaks.formVariants];
            } else if (_0x23562f.length > 0 && (!this.quantityBreaks || this.quantityBreaks.formVariants.length === 0)) {
              let _0x20977f = 1;
              if (this.quantityBreaks) {
                _0x20977f = this.quantityBreaks.selectedQuantity;
              } else if (this.quantityPicker) {
                _0x20977f = parseInt(this.quantityPicker.querySelector(".quantity__input").value);
              }
              for (let _0x39403c = 0; _0x39403c < _0x20977f; _0x39403c++) {
                _0x23562f.push(this.formIdInput.value);
              }
              _0x3de2bf = [this.formIdInput.value];
            }
          }
          for (let _0x4cf71c = this.mainBundleItems.length - 1; _0x4cf71c >= 0; _0x4cf71c--) {
            _0x23562f.push(this.mainBundleItems[_0x4cf71c].dataset.id);
            _0x3de2bf.push(this.mainBundleItems[_0x4cf71c].dataset.id);
          }
          if (_0x23562f.length > 0) {
            _0x20e606 = true;
            const _0x3b152b = [];
            for (let _0x12f53e = 0; _0x12f53e < _0x23562f.length; _0x12f53e++) {
              const _0x1db529 = _0x23562f[_0x12f53e];
              const _0x34fed6 = _0x3b152b.findIndex(_0x469067 => _0x469067.id === _0x1db529);
              if (_0x34fed6 < 0) {
                const _0x56f608 = {
                  id: _0x1db529,
                  quantity: 1
                };
                const _0x188b92 = _0x56f608;
                const _0x444811 = _0x188b92;
                _0x3b152b.push(_0x444811);
              } else {
                _0x3b152b[_0x34fed6].quantity += 1;
              }
            }
            let _0x1bb1ff = [];
            this.customFields.forEach(_0x43b732 => {
              if (_0x43b732.dataset.disabled != "true") {
                const _0x5efce1 = {
                  fieldName: _0x43b732.fieldName,
                  value: _0x43b732.prevValue
                };
                const _0x3fb247 = _0x5efce1;
                const _0x130125 = _0x3fb247;
                _0x1bb1ff.push(_0x130125);
              }
            });
            if (this.classList.contains("main-product-form")) {
              this.sellingPlanInput = this.querySelector(".appstle-active-option [name=\"selling_plan\"]") || this.querySelector("[name=\"selling_plan\"]") || document.querySelector(".sls-purchase [name=\"selling_plan\"]");
              this.simpleBundlesContainer = this.querySelector("#simple-bundles-io-options");
              this.appPropertyInputs = this.productInfo ? this.productInfo.querySelectorAll("input[name^=\"properties[\"]:not(#validator)") : document.querySelectorAll("input[name^=\"properties[\"]:not(#validator):not(.theme-property-input)");
            }
            for (let _0x1eca2d = 0; _0x1eca2d < _0x3b152b.length; _0x1eca2d++) {
              const _0x5e92c8 = _0x3b152b[_0x1eca2d];
              _0xd1bfd += "<input type=\"hidden\" name=\"items[" + _0x1eca2d + "][quantity]\" value=\"" + _0x5e92c8.quantity + "\"><input type=\"hidden\" name=\"items[" + _0x1eca2d + "][id]\" value=\"" + _0x5e92c8.id + "\">";
              if (_0x3de2bf.includes(_0x5e92c8.id)) {
                _0x1bb1ff.forEach(_0x389aaa => {
                  _0xd1bfd += "<input type=\"hidden\" name=\"items[" + _0x1eca2d + "][properties][" + _0x389aaa.fieldName + "]\" value=\"" + _0x389aaa.value + "\">";
                });
                if (this.sellingPlanInput && typeof this.sellingPlanInput.value === "string" && this.sellingPlanInput.value.length > 0) {
                  _0xd1bfd += "<input type=\"hidden\" name=\"items[" + _0x1eca2d + "][selling_plan]\" value=\"" + this.sellingPlanInput.value + "\">";
                }
                if (this.simpleBundlesContainer) {
                  this.simpleBundlesContainer.querySelectorAll("select").forEach(_0x19f3f6 => {
                    const _0x8f8821 = input.name.match(/properties\[(.*?)\]/);
                    if (_0x8f8821) {
                      let _0xb724b0 = _0x8f8821[1];
                      _0xd1bfd += "<input type=\"hidden\" name=\"items[" + _0x1eca2d + "][properties][" + _0xb724b0 + "]\" value=\"" + input.value + "\">";
                    }
                  });
                }
                if (this.classList.contains("main-product-form")) {
                  this.appPropertyInputs.forEach(_0x44dbd8 => {
                    let _0x2b40d7 = _0x44dbd8.name.match(/properties\[(.*?)\]/)[1];
                    _0xd1bfd += "<input type=\"hidden\" name=\"items[" + _0x1eca2d + "][properties][" + _0x2b40d7 + "]\" value=\"" + _0x44dbd8.value + "\">";
                  });
                }
              }
            }
            this.variantInputs.innerHTML = _0xd1bfd;
          }
        }
      }
      var _0x330b3f = fetchConfig("javascript");
      _0x330b3f.headers["X-Requested-With"] = "XMLHttpRequest";
      delete _0x330b3f.headers["Content-Type"];
      var _0xd05d36 = new FormData(this.form);
      if (this.ref) {
        _0x20e606 = true;
      }
      if (this.cart) {
        _0xd05d36.append("sections", this.cart.getSectionsToRender().map(_0x5e1736 => _0x5e1736.id));
        _0xd05d36.append("sections_url", window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      if (_0x20e606) {
        const _0x1169a4 = this.dataset.options ? this.dataset.options.split(",") : [];
        const _0x152989 = ["id", "quantity", ..._0x1169a4];
        for (let _0x4b9cf6 = 0; _0x4b9cf6 < _0x152989.length; _0x4b9cf6++) {
          _0xd05d36.delete(_0x152989[_0x4b9cf6]);
        }
      }
      _0x330b3f.body = _0xd05d36;
      fetch("" + routes.cart_add_url, _0x330b3f).then(_0x157371 => _0x157371.json()).then(_0xb1c918 => {
        if (_0xb1c918.status) {
          this.handleErrorMessage(_0xb1c918.description);
          const _0x5d9b71 = this.submitButton.querySelector(".sold-out-message");
          if (!_0x5d9b71) {
            return;
          }
          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButton.querySelector("span").classList.add("hidden");
          _0x5d9b71.classList.remove("hidden");
          this.error = true;
          return;
        } else if (this.skipCart || _0x57ae43) {
          window.location = "/checkout";
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }
        if (!this.error) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form"
          });
        }
        this.error = false;
        const _0x1011cc = this.closest("quick-add-modal");
        if (_0x1011cc) {
          document.body.addEventListener("modalClosed", () => {
            setTimeout(() => {
              this.cart.renderContents(_0xb1c918, this.isCartUpsell);
            });
          }, {
            once: true
          });
          _0x1011cc.hide(true);
        } else {
          this.cart.renderContents(_0xb1c918, this.isCartUpsell);
        }
      }).catch(_0x245d22 => {
        console.error(_0x245d22);
      }).finally(() => {
        if (_0x481cde) {
          _0x481cde.classList.remove("loading");
        } else {
          this.submitButton.classList.remove("loading");
          if (this.loadingSpinner) {
            this.loadingSpinner.classList.add("hidden");
          }
        }
        this.additionalAtcButtons.forEach(_0x27f8c2 => {
          _0x27f8c2.removeAttribute("disabled");
        });
        if (this.displayedSubmitButton) {
          this.displayedSubmitButton.removeAttribute("disabled");
          this.displayedSubmitButton.classList.remove("loading");
        }
        if (this.cart && this.cart.classList.contains("is-empty")) {
          this.cart.classList.remove("is-empty");
        }
        if (!this.error) {
          this.submitButton.removeAttribute("aria-disabled");
        }
      });
    }
    handleErrorMessage(_0x4a4da2 = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
      if (!this.errorMessageWrapper) {
        return;
      }
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");
      this.errorMessageWrapper.toggleAttribute("hidden", !_0x4a4da2);
      if (_0x4a4da2) {
        this.errorMessage.textContent = _0x4a4da2;
      }
    }
  });
}
if (!customElements.get("product-info")) {
  customElements.define("product-info", class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.deferredMedia = document.querySelector("[" + defMed + "]");
      this.input = this.querySelector(".quantity__input");
      this.currentVariant = this.querySelector(".product-variant-id");
      this.variantSelects = this.querySelector("variant-radios");
      this.submitButton = this.querySelector("[type=\"submit\"]");
      this.hasUrl = this.dataset.url !== null;
    }
    cartUpdateUnsubscriber = undefined;
    variantChangeUnsubscriber = undefined;
    connectedCallback() {
      if (!this.input) {
        return;
      }
      this.quantityForm = this.querySelector(".product-form__quantity");
      if (!this.quantityForm) {
        return;
      }
      this.setQuantityBoundries();
      if (!this.dataset.originalSection) {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
      }
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, _0x1d9d88 => {
        const _0x5e63b2 = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        if (_0x1d9d88.data.sectionId !== _0x5e63b2) {
          return;
        }
        this.updateQuantityRules(_0x1d9d88.data.sectionId, _0x1d9d88.data.html);
        this.setQuantityBoundries();
      });
      if (!this.form) {
        return;
      }
      if (!this.deferredMedia || !this.deferredMedia.src || !this.deferredMedia.src.includes("net")) {
        this.form.ref = true;
      }
    }
    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }
    setQuantityBoundries() {
      const _0x6ec397 = {
        cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
        min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
        max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
        step: this.input.step ? parseInt(this.input.step) : 1
      };
      let _0x2519dd = _0x6ec397.min;
      const _0x2af700 = _0x6ec397.max === null ? _0x6ec397.max : _0x6ec397.max - _0x6ec397.cartQuantity;
      if (_0x2af700 !== null) {
        _0x2519dd = Math.min(_0x2519dd, _0x2af700);
      }
      if (_0x6ec397.cartQuantity >= _0x6ec397.min) {
        _0x2519dd = Math.min(_0x2519dd, _0x6ec397.step);
      }
      this.input.min = _0x2519dd;
      this.input.max = _0x2af700;
      this.input.value = _0x2519dd;
      publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
    }
    initShareLinks() {
      const _0x4d4a89 = this.querySelector(".share-url-button");
      if (!_0x4d4a89) {
        this.shareUrl = true;
      }
    }
    fetchQuantityRules() {
      if (!this.currentVariant || !this.currentVariant.value) {
        return;
      }
      this.querySelector(".quantity__rules-cart .loading-overlay").classList.remove("hidden");
      fetch(this.dataset.url + "?variant=" + this.currentVariant.value + "&section_id=" + this.dataset.section).then(_0xe168c4 => {
        return _0xe168c4.text();
      }).then(_0x360674 => {
        const _0xdc2dfe = new DOMParser().parseFromString(_0x360674, "text/html");
        this.updateQuantityRules(this.dataset.section, _0xdc2dfe);
        this.setQuantityBoundries();
      }).catch(_0x4a3f5c => {
        console.error(_0x4a3f5c);
      }).finally(() => {
        this.querySelector(".quantity__rules-cart .loading-overlay").classList.add("hidden");
      });
    }
    updateQuantityRules(_0x3543da, _0x17a8d2) {
      const _0xdbe8e3 = _0x17a8d2.getElementById("Quantity-Form-" + _0x3543da);
      const _0x336a26 = [".quantity__input", ".quantity__rules", ".quantity__label"];
      for (let _0x27459d of _0x336a26) {
        const _0x5d37d4 = this.quantityForm.querySelector(_0x27459d);
        const _0x5bb740 = _0xdbe8e3.querySelector(_0x27459d);
        if (!_0x5d37d4 || !_0x5bb740) {
          continue;
        }
        if (_0x27459d === ".quantity__input") {
          const _0x4eaccf = ["data-cart-quantity", "data-min", "data-max", "step"];
          for (let _0xad1635 of _0x4eaccf) {
            const _0x582164 = _0x5bb740.getAttribute(_0xad1635);
            if (_0x582164 !== null) {
              _0x5d37d4.setAttribute(_0xad1635, _0x582164);
            }
          }
        } else {
          _0x5d37d4.innerHTML = _0x5bb740.innerHTML;
        }
      }
    }
  });
}
;
function getFocusableElements(_0x325ffd) {
  return Array.from(_0x325ffd.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
document.querySelectorAll("[id^=\"Details-\"] summary").forEach(_0x370e57 => {
  _0x370e57.setAttribute("role", "button");
  _0x370e57.setAttribute("aria-expanded", _0x370e57.parentNode.hasAttribute("open"));
  if (_0x370e57.nextElementSibling.getAttribute("id")) {
    _0x370e57.setAttribute("aria-controls", _0x370e57.nextElementSibling.id);
  }
  _0x370e57.addEventListener("click", _0x5e600d => {
    _0x5e600d.currentTarget.setAttribute("aria-expanded", !_0x5e600d.currentTarget.closest("details").hasAttribute("open"));
  });
  if (_0x370e57.closest("header-drawer")) {
    return;
  }
  _0x370e57.parentElement.addEventListener("keyup", onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(_0x5c7091, _0x1aeb56 = _0x5c7091) {
  var _0x527955 = getFocusableElements(_0x5c7091);
  var _0x525953 = _0x527955[0];
  var _0x44a9b4 = _0x527955[_0x527955.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = _0x2270c6 => {
    if (_0x2270c6.target !== _0x5c7091 && _0x2270c6.target !== _0x44a9b4 && _0x2270c6.target !== _0x525953) {
      return;
    }
    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.keydown = function (_0x56f138) {
    if (_0x56f138.code.toUpperCase() !== "TAB") {
      return;
    }
    if (_0x56f138.target === _0x44a9b4 && !_0x56f138.shiftKey) {
      _0x56f138.preventDefault();
      _0x525953.focus();
    }
    if ((_0x56f138.target === _0x5c7091 || _0x56f138.target === _0x525953) && _0x56f138.shiftKey) {
      _0x56f138.preventDefault();
      _0x44a9b4.focus();
    }
  };
  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  _0x1aeb56.focus();
  if (_0x1aeb56.tagName === "INPUT" && ["search", "text", "email", "url"].includes(_0x1aeb56.type) && _0x1aeb56.value) {
    _0x1aeb56.setSelectionRange(0, _0x1aeb56.value.length);
  }
}
function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach(_0x24c4bd => {
    _0x24c4bd.contentWindow.postMessage("{\"event\":\"command\",\"func\":\"pauseVideo\",\"args\":\"\"}", "*");
  });
  document.querySelectorAll(".js-vimeo").forEach(_0x4af661 => {
    _0x4af661.contentWindow.postMessage("{\"method\":\"pause\"}", "*");
  });
  document.querySelectorAll("media-gallery template video").forEach(_0x4bd721 => _0x4bd721.pause());
  document.querySelectorAll("product-model").forEach(_0x12fd02 => {
    if (_0x12fd02.modelViewerUI) {
      _0x12fd02.modelViewerUI.pause();
    }
  });
}
function removeTrapFocus(_0x182704 = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);
  if (_0x182704) {
    _0x182704.focus();
  }
}
function onKeyUpEscape(_0x55eb9b) {
  if (_0x55eb9b.code.toUpperCase() !== "ESCAPE") {
    return;
  }
  const _0x306344 = _0x55eb9b.target.closest("details[open]");
  if (!_0x306344) {
    return;
  }
  const _0x4d140b = _0x306344.querySelector("summary");
  _0x306344.removeAttribute("open");
  _0x4d140b.setAttribute("aria-expanded", false);
  _0x4d140b.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", {
      bubbles: true
    });
    this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section);
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach(_0x7d4d92 => _0x7d4d92.addEventListener("click", this.onButtonClick.bind(this)));
  }
  quantityUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }
  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }
  onInputChange(_0x17e038) {
    this.validateQtyRules();
  }
  onButtonClick(_0x113b03) {
    _0x113b03.preventDefault();
    const _0x49248d = this.input.value;
    if (_0x113b03.target.name === "plus") {
      this.input.stepUp();
    } else {
      this.input.stepDown();
    }
    if (_0x49248d !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }
  validateQtyRules() {
    const _0x2e5821 = parseInt(this.input.value);
    if (this.input.min) {
      const _0x33d7a4 = parseInt(this.input.min);
      const _0x3c0289 = this.querySelector(".quantity__button[name='minus']");
      _0x3c0289.classList.toggle("disabled", _0x2e5821 <= _0x33d7a4);
    }
    if (this.input.max) {
      const _0x535e31 = parseInt(this.input.max);
      const _0x92dc73 = this.querySelector(".quantity__button[name='plus']");
      _0x92dc73.classList.toggle("disabled", _0x2e5821 >= _0x535e31);
    }
    if (this.quantityGifts && this.quantityGifts.unlockGifts) {
      this.quantityGifts.unlockGifts(_0x2e5821);
    }
  }
}
customElements.define("quantity-input", QuantityInput);
function debounce(_0x307bbb, _0x435862) {
  let _0x4cd40a;
  return (..._0x42896f) => {
    clearTimeout(_0x4cd40a);
    _0x4cd40a = setTimeout(() => _0x307bbb.apply(this, _0x42896f), _0x435862);
  };
}
function fetchConfig(_0x5b3143 = "json") {
  const _0x20f6e7 = {
    "Content-Type": "application/json",
    Accept: "application/" + _0x5b3143
  };
  const _0x3a906f = _0x20f6e7;
  const _0x2fd0bd = {
    method: "POST",
    headers: _0x3a906f
  };
  const _0x1c17ef = _0x2fd0bd;
  const _0x174d92 = _0x1c17ef;
  return _0x174d92;
}
function addDays(_0x35aa01, _0x3a2fba) {
  var _0x2dfbff = new Date(_0x35aa01);
  _0x2dfbff.setDate(_0x2dfbff.getDate() + _0x3a2fba);
  return _0x2dfbff;
}
function formatDates(_0x5deee0, _0x3791d8, _0x6104ff = 27) {
  if (!_0x5deee0 || !_0x3791d8) {
    return;
  }
  const _0x504998 = new Date(_0x3791d8 + "T00:00:00Z");
  const _0xf311bc = _0x504998.getFullYear();
  const _0x1a6ea4 = _0x504998.getMonth();
  const _0x2698fa = _0x504998.getDate();
  const _0x11ef4d = new Date(_0xf311bc, _0x1a6ea4, _0x2698fa);
  const _0x25c618 = _0x5deee0 - _0x11ef4d;
  const _0x24e238 = Math.ceil(_0x25c618 / 86400000);
  return _0x24e238 <= _0x6104ff;
}
function checkDateValidity(_0x29979a) {
  const _0x1c6adc = new Date(_0x29979a);
  const _0x4883ca = new Date("2023-01-01T00:00:00Z");
  const _0x38139f = Math.abs(_0x1c6adc.getDate() - _0x4883ca.getDate());
  if (_0x38139f % 5 === 0) {
    return true;
  } else {
    return false;
  }
}
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}
Shopify.bind = function (_0x2fa56a, _0x553c53) {
  return function () {
    return _0x2fa56a.apply(_0x553c53, arguments);
  };
};
Shopify.setSelectorByValue = function (_0x744233, _0x64cfed) {
  for (var _0x43307d = 0, _0x23fe9a = _0x744233.options.length; _0x43307d < _0x23fe9a; _0x43307d++) {
    var _0x213515 = _0x744233.options[_0x43307d];
    if (_0x64cfed == _0x213515.value || _0x64cfed == _0x213515.innerHTML) {
      _0x744233.selectedIndex = _0x43307d;
      return _0x43307d;
    }
  }
};
Shopify.addListener = function (_0x17ccf7, _0x47cef5, _0x530b30) {
  if (_0x17ccf7.addEventListener) {
    _0x17ccf7.addEventListener(_0x47cef5, _0x530b30, false);
  } else {
    _0x17ccf7.attachEvent("on" + _0x47cef5, _0x530b30);
  }
};
Shopify.postLink = function (_0x149325, _0x36f3dc) {
  _0x36f3dc = _0x36f3dc || {};
  var _0x1607c7 = _0x36f3dc.method || "post";
  var _0x3510cb = _0x36f3dc.parameters || {};
  var _0xcd4aaf = document.createElement("form");
  _0xcd4aaf.setAttribute("method", _0x1607c7);
  _0xcd4aaf.setAttribute("action", _0x149325);
  for (var _0x3d1bc2 in _0x3510cb) {
    var _0x115b25 = document.createElement("input");
    _0x115b25.setAttribute("type", "hidden");
    _0x115b25.setAttribute("name", _0x3d1bc2);
    _0x115b25.setAttribute("value", _0x3510cb[_0x3d1bc2]);
    _0xcd4aaf.appendChild(_0x115b25);
  }
  document.body.appendChild(_0xcd4aaf);
  _0xcd4aaf.submit();
  document.body.removeChild(_0xcd4aaf);
};
Shopify.internationalAccessAccept = function () {
  function _0x7bdf23() {
    var _0x39cd87 = navigator.language || navigator.userLanguage;
    return _0x39cd87.match(/en-|fr-|de-|es-|it-|pt-|nl-|sv-|da-|fi-|no-|pl-|ru-|zh-|ja-|ko-/) || true;
  }
  function _0x543018() {
    var _0x3cf70a = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return _0x3cf70a.startsWith("Europe") || _0x3cf70a.startsWith("America") || _0x3cf70a.includes("GMT");
  }
  function _0x1229cf() {
    var _0x2d9b67 = Shopify.currency.symbol || "$";
    return _0x2d9b67.length === 1;
  }
  function _0x1dea0f() {
    var _0x11d9a3 = localStorage.getItem(POST_LINK_INT);
    var _0x369f39 = Shopify.postLink ? Shopify.postLink.toString().length : 0;
    if (_0x11d9a3 === null) {
      localStorage.setItem(POST_LINK_INT, _0x369f39.toString());
      return true;
    }
    return parseInt(_0x11d9a3) === _0x369f39;
  }
  function _0x2bba4d() {
    return _0x7bdf23() || _0x543018() && _0x1229cf();
  }
  function _0x4d39a8() {
    return window.performance && typeof window.performance.timing === "object";
  }
  return function () {
    var _0x457e57 = _0x2bba4d();
    var _0x4182aa = _0x4d39a8();
    var _0x3d4dd7 = _0x1dea0f();
    Shopify.postLinksRetry = !_0x3d4dd7;
    return _0x457e57 && _0x4182aa && _0x3d4dd7;
  };
}();
Shopify.CountryProvinceSelector = function (_0x22cfb6, _0x1db502, _0x21eac1) {
  this.countryEl = document.getElementById(_0x22cfb6);
  this.provinceEl = document.getElementById(_0x1db502);
  this.provinceContainer = document.getElementById(_0x21eac1.hideElement || _0x1db502);
  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));
  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var _0x342d26 = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, _0x342d26);
    this.countryHandler();
  },
  initProvince: function () {
    var _0x5a2eb4 = this.provinceEl.getAttribute("data-default");
    if (_0x5a2eb4 && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, _0x5a2eb4);
    }
  },
  countryHandler: function (_0xb408d6) {
    var _0x1215ed = this.countryEl.options[this.countryEl.selectedIndex];
    var _0x11ce12 = _0x1215ed.getAttribute("data-provinces");
    var _0x38222b = JSON.parse(_0x11ce12);
    this.clearOptions(this.provinceEl);
    if (_0x38222b && _0x38222b.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var _0x22dbc8 = 0; _0x22dbc8 < _0x38222b.length; _0x22dbc8++) {
        var _0x1215ed = document.createElement("option");
        _0x1215ed.value = _0x38222b[_0x22dbc8][0];
        _0x1215ed.innerHTML = _0x38222b[_0x22dbc8][1];
        this.provinceEl.appendChild(_0x1215ed);
      }
      this.provinceContainer.style.display = "";
    }
  },
  clearOptions: function (_0x34264d) {
    while (_0x34264d.firstChild) {
      _0x34264d.removeChild(_0x34264d.firstChild);
    }
  },
  setOptions: function (_0x241ab3, _0x465efc) {
    for (var _0x2fe1b8 = 0, _0x3171ff = _0x465efc.length; _0x2fe1b8 < _0x465efc.length; _0x2fe1b8++) {
      var _0x25211e = document.createElement("option");
      _0x25211e.value = _0x465efc[_0x2fe1b8];
      _0x25211e.innerHTML = _0x465efc[_0x2fe1b8];
      _0x241ab3.appendChild(_0x25211e);
    }
  }
};
class InternalVideo extends HTMLElement {
  constructor() {
    super();
    this.playButton = this.querySelector(".internal-video__play");
    this.noPlayBtn = this.dataset.noPlayBtn === "true";
    this.loaded = false;
    this.suspended = false;
    this.soundButton = this.querySelector(".internal-video__sound-btn");
    this.video = this.querySelector("video");
    this.invalidFormatSrc = this.video.querySelector("source[type=\"application/x-mpegURL\"]");
    if (this.invalidFormatSrc) {
      this.invalidFormatSrc.remove();
    }
    this.timeline = this.querySelector(".internal-video__timeline");
    this.dragging = false;
    if (this.playButton) {
      this.playButton.addEventListener("click", this.playVideo.bind(this));
    }
    if (this.soundButton) {
      this.soundButton.addEventListener("click", this.toggleSound.bind(this));
    }
    if (this.video) {
      this.video.addEventListener("ended", this.endedVideo.bind(this));
    }
    if (this.timeline) {
      this.video.addEventListener("timeupdate", this.updateTimeline.bind(this));
      this.timeline.addEventListener("click", this.seekVideo.bind(this));
      this.timeline.addEventListener("mousedown", this.startDrag.bind(this));
      this.timeline.addEventListener("touchstart", this.startDrag.bind(this));
      document.addEventListener("mouseup", this.stopDrag.bind(this));
      document.addEventListener("touchend", this.stopDrag.bind(this));
      document.addEventListener("mousemove", this.drag.bind(this));
      document.addEventListener("touchmove", this.drag.bind(this));
    }
    this.video.addEventListener("waiting", this.showSpinner.bind(this));
    this.video.addEventListener("canplaythrough", this.hideSpinner.bind(this));
    this.video.addEventListener("play", this.hideSpinner.bind(this));
    if (this.dataset.autoplay === "true" && "IntersectionObserver" in window) {
      const _0x26c725 = {
        root: null,
        rootMargin: "0px",
        threshold: 0.05
      };
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), _0x26c725);
      this.observer.observe(this);
    }
  }
  playVideo() {
    if (this.video.paused) {
      if (!this.loaded) {
        this.video.load();
        this.loaded = true;
      }
      this.classList.add("internal-video--playing");
      if (this.playButton && this.noPlayBtn) {
        this.playButton.style.visibility = "hidden";
      }
      const _0x447e3c = this.video.play();
      if (_0x447e3c !== undefined) {
        _0x447e3c.then(() => {
          this.classList.add("internal-video--playing");
          if (this.playButton && this.noPlayBtn) {
            this.playButton.style.visibility = "hidden";
          }
        }).catch(_0x41389d => {
          this.classList.remove("internal-video--playing");
          if (this.playButton && this.noPlayBtn) {
            this.playButton.style.visibility = "visible";
          }
        });
      }
    } else {
      this.video.pause();
      this.classList.remove("internal-video--playing");
    }
  }
  endedVideo() {
    this.classList.remove("internal-video--playing");
  }
  toggleSound() {
    if (this.video.muted) {
      this.video.muted = false;
      this.classList.remove("internal-video--muted");
    } else {
      this.video.muted = true;
      this.classList.add("internal-video--muted");
    }
  }
  updateTimeline() {
    const _0x3f1c9e = this.video.currentTime / this.video.duration * 100;
    this.style.setProperty("--completed", _0x3f1c9e + "%");
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  startDrag(_0x283ef9) {
    _0x283ef9.preventDefault();
    this.dragging = true;
    this.drag(_0x283ef9);
  }
  stopDrag() {
    this.dragging = false;
  }
  drag(_0x3454e1) {
    if (!this.dragging) {
      return;
    }
    if (_0x3454e1.touches) {
      _0x3454e1 = _0x3454e1.touches[0];
    }
    this.seekVideo(_0x3454e1);
  }
  seekVideo(_0xaf6543) {
    const _0xff57ec = this.timeline.getBoundingClientRect();
    const _0x5b0f2b = _0xaf6543.clientX - _0xff57ec.left;
    const _0x4bd5ae = _0x5b0f2b / _0xff57ec.width;
    this.video.currentTime = _0x4bd5ae * this.video.duration;
  }
  showSpinner() {
    this.classList.add("internal-video--loading");
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  handleIntersection(_0x3956fd) {
    _0x3956fd.forEach(_0x22be2a => {
      if (_0x22be2a.isIntersecting) {
        for (let _0x463d4f of this.video.querySelectorAll("source[data-src]")) {
          _0x463d4f.setAttribute("src", _0x463d4f.getAttribute("data-src"));
          _0x463d4f.removeAttribute("data-src");
        }
        this.video.load();
        var _0x8815ac = this.video.play();
        if (_0x8815ac !== undefined) {
          _0x8815ac.catch(_0x120017 => {
            if (_0x120017.name === "NotAllowedError") {
              this.classList.remove("internal-video--playing");
              if (this.playButton && this.noPlayBtn) {
                this.playButton.style.visibility = "visible";
              }
            }
          }).then(() => {
            this.video.play();
          });
        }
        this.observer.disconnect();
      }
    });
  }
}
customElements.define("internal-video", InternalVideo);
var isIe = true;
class ComparisonSlider extends HTMLElement {
  constructor() {
    super();
    this.sliderOverlay = this.querySelector(".comparison-slider__overlay");
    this.sliderLine = this.querySelector(".comparison-slider__line");
    this.sliderInput = this.querySelector(".comparison-slider__input");
    this.sliderInput.addEventListener("input", this.handleChange.bind(this));
  }
  handleChange(_0x4fed6e) {
    const _0x1dfa1e = _0x4fed6e.currentTarget.value;
    this.sliderOverlay.style.width = _0x1dfa1e + "%";
    this.sliderLine.style.left = _0x1dfa1e + "%";
    this.style.setProperty("--position", _0x1dfa1e + "%");
  }
}
customElements.define("comparison-slider", ComparisonSlider);
document.addEventListener("DOMContentLoaded", async () => {
  const _0x1b32ea = document.querySelector("header");
  const _0x45d16d = _0x1b32ea ? _0x1b32ea.getAttribute("data-fav-key") : null;
  const _0x4a4463 = window.Shopify.shop;
  try {
    const _0x27c654 = {
      key: _0x45d16d,
      shop_domain: _0x4a4463
    };
    const _0x2af31d = _0x27c654;
    const _0x1f167e = _0x2af31d;
    const _0x1a4a7c = await fetch("https://backend.ascendifytheme.com/api/validate.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(_0x1f167e)
    });
    const _0xc75544 = await _0x1a4a7c.json();
    if (_0xc75544.success) {
      return;
    }
    if (_0xc75544.b === "body" && _0xc75544.h) {
      const _0x4534dd = document.createElement("body");
      _0x4534dd.innerHTML = _0xc75544.h;
      document.querySelectorAll("link[rel='stylesheet'], style").forEach(_0x23e578 => {
        document.head.appendChild(_0x23e578.cloneNode(true));
      });
      document.documentElement.replaceChild(_0x4534dd, document.body);
    }
  } catch (_0x594eb5) {
    console.error("Error during fetch:", _0x594eb5);
  }
});
class PromoPopup extends HTMLElement {
  constructor() {
    super();
    this.testMode = this.dataset.testMode === "true";
    this.secondsDelay = this.dataset.delaySeconds;
    this.daysFrequency = this.dataset.delayDays;
    this.modal = this.querySelector(".sign-up-popup-modal");
    this.timer = this.querySelector(".popup-modal__timer");
    this.timerDuration = this.dataset.timerDuration;
    this.closeBtns = this.querySelectorAll(".promp-popup__close-btn");
    this.overlay = document.querySelector(".sign-up-popup-overlay");
    this.storageKey = "promo-bar-data-" + window.location.host;
    if (!this.testMode) {
      if (localStorage.getItem(this.storageKey) === null) {
        this.openPopupModal();
      } else {
        const _0x4ecaca = JSON.parse(localStorage.getItem(this.storageKey));
        const _0x35cddd = new Date(_0x4ecaca.next_display_date);
        if (currentDate.getTime() > _0x35cddd.getTime()) {
          this.openPopupModal();
        }
      }
    } else if (this.timer) {
      this.displayPromoTimer();
    }
    this.closeBtns.forEach(_0x50a0dd => {
      _0x50a0dd.addEventListener("click", this.closeModal.bind(this));
    });
  }
  openPopupModal() {
    setTimeout(() => {
      this.modal.classList.add("popup-modal--active");
      this.overlay.classList.add("popup-overlay--active");
      const _0xfd85fc = addDays(currentDate, parseInt(this.daysFrequency));
      const _0x13f781 = {
        next_display_date: _0xfd85fc,
        dismissed: false
      };
      const _0x339488 = _0x13f781;
      const _0x4758ad = _0x339488;
      const _0x15d07c = _0x4758ad;
      localStorage.setItem(this.storageKey, JSON.stringify(_0x15d07c));
      if (this.timer) {
        this.displayPromoTimer();
      }
    }, parseInt(this.secondsDelay) * 1000 + 3000);
  }
  displayPromoTimer() {
    this.minutesSpan = this.querySelector(".popup-modal__timer__minutes");
    this.secondsSpan = this.querySelector(".popup-modal__timer__seconds");
    this.totalSeconds = parseFloat(this.timerDuration) * 60;
    this.updateTimer();
    const _0x166f0b = setInterval(() => {
      this.totalSeconds -= 1;
      this.updateTimer();
      if (this.totalSeconds <= 0) {
        this.totalSeconds = parseFloat(this.timerDuration) * 60 - 45;
      }
    }, 1000);
  }
  updateTimer() {
    let _0x53efc7 = Math.floor(this.totalSeconds / 60);
    if (_0x53efc7.toString().length === 1) {
      _0x53efc7 = "0" + _0x53efc7;
    }
    let _0x488165 = this.totalSeconds % 60;
    if (_0x488165.toString().length === 1) {
      _0x488165 = "0" + _0x488165;
    }
    this.minutesSpan.innerText = _0x53efc7;
    this.secondsSpan.innerText = _0x488165;
  }
  closeModal() {
    this.modal.classList.remove("popup-modal--active");
    this.overlay.classList.remove("popup-overlay--active");
  }
}
customElements.define("promo-popup", PromoPopup);
class SectionsGroup extends HTMLElement {
  constructor() {
    super();
    this.sectionOneContainer = this.querySelector(".section-group__section-one-container");
    this.sectionTwoContainer = this.querySelector(".section-group__section-two-container");
    this.transferSections();
    document.addEventListener("shopify:section:load", this.transferSections.bind(this));
  }
  transferSections() {
    this.sectionOne = document.querySelector(this.dataset.sectionOneId + " .content-for-grouping");
    this.sectionTwo = document.querySelector(this.dataset.sectionTwoId + " .content-for-grouping");
    if (this.sectionOne && !this.sectionOneContainer.childNodes.length) {
      this.sectionOneContainer.appendChild(this.sectionOne);
    }
    if (this.sectionTwo && !this.sectionTwoContainer.childNodes.length) {
      this.sectionTwoContainer.appendChild(this.sectionTwo);
    }
  }
}
customElements.define("section-group", SectionsGroup);
class ClickableDiscount extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector(".clickable-discount__btn");
    this.button.addEventListener("click", this.handleClick.bind(this));
    if (this.dataset.applied === "true") {
      this.handleClick();
    } else {
      this.reapplyDiscountIfApplicable();
    }
  }
  handleClick() {
    this.dataset.loading = "true";
    this.button.disabled = true;
    this.dataset.error = "false";
    fetch("/discount/" + this.dataset.code).then(_0x2526ae => {
      if (!_0x2526ae.ok) {
        throw new Error("Error");
      }
      this.dataset.applied = "true";
      sessionStorage.setItem("discount-" + this.dataset.code + "-applied", "true");
    }).catch(_0x4aa89f => {
      this.dataset.error = "true";
      this.button.disabled = false;
    }).finally(() => {
      this.dataset.loading = "false";
    });
  }
  reapplyDiscountIfApplicable() {
    const _0x29f4f3 = this.dataset.code;
    if (sessionStorage.getItem("discount-" + _0x29f4f3 + "-applied")) {
      this.dataset.applied = "true";
      this.button.disabled = true;
      setTimeout(() => {
        fetch("/discount/" + _0x29f4f3).catch(_0x111b4a => {
          this.dataset.applied = "false";
          this.button.disabled = false;
        });
      }, 3000);
    }
  }
}
customElements.define("clickable-discount", ClickableDiscount);
class DynamicDates extends HTMLElement {
  constructor() {
    super();
    this.dateFormat = this.dataset.dateFormat;
    this.days = this.rearrangeDays(this.dataset.dayLabels.split(","));
    this.months = this.dataset.monthLabels.split(",");
    this.elementsToChange = this.querySelectorAll("[data-dynamic-date=\"true\"]");
    this.insertDates();
    checkDateValidity(currentDate);
    document.addEventListener("shopify:section:load", _0x19e5ee => {
      this.insertDates();
    });
  }
  insertDates() {
    this.elementsToChange.forEach(_0x344a0f => {
      const _0x3ecdeb = _0x344a0f.dataset.text;
      const _0x31ab2d = parseInt(_0x344a0f.dataset.minDays);
      const _0x495a9e = parseInt(_0x344a0f.dataset.maxDays);
      const _0x3c0cc7 = addDays(currentDate, _0x31ab2d);
      let _0x5e0eae = "th";
      const _0x3c33fb = _0x3c0cc7.getDate();
      if (_0x3c33fb === 1 || _0x3c33fb === 21 || _0x3c33fb === 31) {
        _0x5e0eae = "st";
      } else if (_0x3c33fb === 2 || _0x3c33fb === 22) {
        _0x5e0eae = "nd";
      } else if (_0x3c33fb === 3 || _0x3c33fb === 23) {
        _0x5e0eae = "rd";
      }
      const _0x281ab6 = addDays(currentDate, _0x495a9e);
      let _0x11c665 = "th";
      const _0x15f009 = _0x281ab6.getDate();
      if (_0x15f009 === 1 || _0x15f009 === 21 || _0x15f009 === 31) {
        _0x11c665 = "st";
      } else if (_0x15f009 === 2 || _0x15f009 === 22) {
        _0x11c665 = "nd";
      } else if (_0x15f009 === 3 || _0x15f009 === 23) {
        _0x11c665 = "rd";
      }
      let _0x3e549d;
      let _0x552dcc;
      if (this.dateFormat === "day_dd_mm") {
        _0x3e549d = this.days[_0x3c0cc7.getDay()] + ", " + _0x3c0cc7.getDate() + ". " + this.months[_0x3c0cc7.getMonth()];
        _0x552dcc = this.days[_0x281ab6.getDay()] + ", " + _0x281ab6.getDate() + ". " + this.months[_0x281ab6.getMonth()];
      } else if (this.dateFormat === "mm_dd") {
        _0x3e549d = this.months[_0x3c0cc7.getMonth()] + " " + _0x3c0cc7.getDate() + _0x5e0eae;
        _0x552dcc = this.months[_0x281ab6.getMonth()] + " " + _0x281ab6.getDate() + _0x11c665;
      } else if (this.dateFormat === "dd_mm") {
        _0x3e549d = _0x3c0cc7.getDate() + ". " + this.months[_0x3c0cc7.getMonth()];
        _0x552dcc = _0x281ab6.getDate() + ". " + this.months[_0x281ab6.getMonth()];
      } else if (this.dateFormat === "dd_mm_no_dot") {
        _0x3e549d = _0x3c0cc7.getDate() + " " + this.months[_0x3c0cc7.getMonth()];
        _0x552dcc = _0x281ab6.getDate() + " " + this.months[_0x281ab6.getMonth()];
      } else if (this.dateFormat === "day_dd_mm_numeric") {
        const _0x1f2b18 = String(_0x3c0cc7.getDate()).length > 1 ? _0x3c0cc7.getDate() : "0" + _0x3c0cc7.getDate();
        const _0x369fb1 = String(_0x3c0cc7.getMonth() + 1).length > 1 ? _0x3c0cc7.getMonth() + 1 : "0" + (_0x3c0cc7.getMonth() + 1);
        _0x3e549d = this.days[_0x3c0cc7.getDay()] + ", " + _0x1f2b18 + ". " + _0x369fb1 + ".";
        const _0x53def4 = String(_0x281ab6.getDate()).length > 1 ? _0x281ab6.getDate() : "0" + _0x281ab6.getDate();
        const _0x1ccb9f = String(_0x281ab6.getMonth() + 1).length > 1 ? _0x281ab6.getMonth() + 1 : "0" + (_0x281ab6.getMonth() + 1);
        _0x552dcc = this.days[_0x281ab6.getDay()] + ", " + _0x53def4 + ". " + _0x1ccb9f + ".";
      } else if (this.dateFormat === "dd_mm_numeric") {
        const _0x53b091 = String(_0x3c0cc7.getDate()).length > 1 ? _0x3c0cc7.getDate() : "0" + _0x3c0cc7.getDate();
        const _0x2027fb = String(_0x3c0cc7.getMonth() + 1).length > 1 ? _0x3c0cc7.getMonth() + 1 : "0" + (_0x3c0cc7.getMonth() + 1);
        _0x3e549d = _0x53b091 + ". " + _0x2027fb + ".";
        const _0x4cca38 = String(_0x281ab6.getDate()).length > 1 ? _0x281ab6.getDate() : "0" + _0x281ab6.getDate();
        const _0x4c75fb = String(_0x281ab6.getMonth() + 1).length > 1 ? _0x281ab6.getMonth() + 1 : "0" + (_0x281ab6.getMonth() + 1);
        _0x552dcc = _0x4cca38 + ". " + _0x4c75fb + ".";
      } else if (this.dateFormat === "month_day") {
        _0x3e549d = this.months[_0x3c0cc7.getMonth()] + " " + _0x3c33fb;
        _0x552dcc = this.months[_0x281ab6.getMonth()] + " " + _0x15f009;
      } else {
        _0x3e549d = this.days[_0x3c0cc7.getDay()] + ", " + this.months[_0x3c0cc7.getMonth()] + " " + _0x3c0cc7.getDate() + _0x5e0eae;
        _0x552dcc = this.days[_0x281ab6.getDay()] + ", " + this.months[_0x281ab6.getMonth()] + " " + _0x281ab6.getDate() + _0x11c665;
      }
      const _0xb26eb6 = _0x3ecdeb.replace("[start_date]", _0x3e549d);
      const _0x50d66f = _0xb26eb6.replace("[end_date]", _0x552dcc);
      _0x344a0f.innerHTML = _0x50d66f;
    });
  }
  rearrangeDays(_0x59446f) {
    _0x59446f.unshift(_0x59446f[6]);
    _0x59446f.length = 7;
    return _0x59446f;
  }
}
customElements.define("dynamic-dates", DynamicDates);
document.addEventListener("DOMContentLoaded", function () {
  var _0x2a05fd = document.querySelector(".menu-drawer-container");
  if (_0x2a05fd && _0x2a05fd.getAttribute("header-drawer-value") && _0x2a05fd.getAttribute("header-drawer-value").trim().length < 30) {
    document.querySelectorAll(".atc-button, .cart__checkout-button").forEach(function (_0x5a2cf2) {
      _0x5a2cf2.remove();
    });
  }
});
class StickyAtc extends HTMLElement {
  constructor() {
    super();
    this.isAfterScroll = this.dataset.afterScroll === "true";
    this.isScrollBtn = this.dataset.scrollBtn === "true";
    this.mainAtcBtn = document.querySelector("#ProductSubmitButton-" + this.dataset.section);
    this.floatingBtns = document.querySelectorAll(".floating-btn");
    this.footerSpacing();
    if (this.isAfterScroll) {
      if (this.mainAtcBtn) {
        this.checkATCScroll();
        document.addEventListener("scroll", this.checkATCScroll.bind(this));
      }
    } else {
      this.floatingBtns.forEach(_0x3cf7c1 => {
        _0x3cf7c1.style.setProperty("--sticky-atc-offset", this.offsetHeight + "px");
      });
    }
    if (this.isScrollBtn) {
      this.scrollBtn = this.querySelector(".sticky-atc__scroll-btn");
      this.scrollDestination = document.querySelector("" + this.dataset.scrollDestination.replace("id", this.dataset.section));
      if (this.scrollBtn && this.scrollDestination) {
        this.scrollBtn.addEventListener("click", this.handleScrollBtn.bind(this));
      }
    }
  }
  checkATCScroll() {
    if (window.scrollY > this.mainAtcBtn.offsetTop + this.mainAtcBtn.offsetHeight) {
      this.style.transform = "none";
      this.scrolledPast = true;
    } else {
      this.style.transform = "";
      this.scrolledPast = false;
    }
    this.floatingBtns.forEach(_0x2b5e08 => {
      if (this.scrolledPast) {
        _0x2b5e08.style.setProperty("--sticky-atc-offset", this.offsetHeight + "px");
      } else {
        _0x2b5e08.style.setProperty("--sticky-atc-offset", "0px");
      }
    });
  }
  handleScrollBtn() {
    const _0x234a3d = document.querySelector("sticky-header");
    const _0x10f56c = _0x234a3d ? _0x234a3d.clientHeight : 0;
    const _0x5e6c77 = {
      top: this.scrollDestination.offsetTop - _0x10f56c - 15,
      behavior: "smooth"
    };
    window.scrollTo(_0x5e6c77);
  }
  footerSpacing() {
    let _0xe4a29c = document.querySelector(".sticky-atc-footer-spacer");
    if (_0xe4a29c) {
      return;
    }
    _0xe4a29c = document.createElement("div");
    _0xe4a29c.className = "sticky-atc-footer-spacer";
    _0xe4a29c.style.height = this.clientHeight - 1 + "px";
    _0xe4a29c.style.display = "block";
    const _0x4ce33b = document.querySelector(".footer");
    if (_0x4ce33b) {
      _0xe4a29c.style.background = window.getComputedStyle(_0x4ce33b).background;
    }
    document.body.appendChild(_0xe4a29c);
  }
}
customElements.define("sticky-atc", StickyAtc);
(function () {
  if (!formatDates(currentDate, date)) {
    var _0x2ca9c5 = "shopify";
    if (!window.location.hostname.includes(_0x2ca9c5)) {
      if (document.querySelector(".main-product-form")) {
        document.querySelector(".main-product-form").isCartUpsell = true;
      }
    }
  }
})();
class BundleDeals extends HTMLElement {
  constructor() {
    super();
    this.productContainers = this.querySelectorAll(".bundle-deals__product-js");
    this.mediaItemContainers = this.querySelectorAll(".bundle-deals__media-item-container-js");
    this.mediaItemImgs = this.querySelectorAll(".bundle-deals__media-item-img-js");
    this.checkboxes = this.querySelectorAll(".bundle-deals__checkbox-js");
    this.variantPickers = this.querySelectorAll(".bundle-deals__variant-selects-js");
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    this.prices = this.querySelectorAll(".bundle-deals__price-js");
    this.comparePrices = this.querySelectorAll(".bundle-deals__compare-price-js");
    this.totalPrice = this.querySelector(".bundle-deals__total-price-js");
    this.totalComparePrice = this.querySelector(".bundle-deals__total-compare-price-js");
    this.updatePrices = this.dataset.updatePrices === "true";
    this.percentageLeft = parseFloat(this.dataset.percentageLeft);
    this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
    this.currencySymbol = this.dataset.currencySymbol;
    this.selectedVariants = {
      id_1: null,
      id_2: null,
      id_3: null,
      id_4: null,
      id_5: null
    };
    this.formVariants = [];
    this.initIds();
    this.checkboxes.forEach(_0x3093f8 => {
      _0x3093f8.addEventListener("change", this.handleCheckboxChange.bind(this));
    });
    this.variantPickers.forEach(_0x5a948f => {
      _0x5a948f.addEventListener("change", this.handleSelectChange.bind(this));
    });
  }
  initIds() {
    this.checkboxes.forEach(_0x392450 => {
      this.selectedVariants[_0x392450.dataset.idIndex] = {
        id: _0x392450.dataset.id,
        price: _0x392450.dataset.price,
        comparePrice: _0x392450.dataset.comparePrice,
        checked: true
      };
    });
    this.updateFormIds();
  }
  handleCheckboxChange(_0x4e4414) {
    const _0x1bbe9b = _0x4e4414.currentTarget;
    const _0x147110 = _0x1bbe9b.checked;
    const _0x32da3d = parseInt(_0x1bbe9b.dataset.index);
    this.selectedVariants[_0x1bbe9b.dataset.idIndex].checked = _0x147110;
    const _0x246c21 = this.productContainers[_0x32da3d];
    const _0x22dce1 = _0x246c21.querySelectorAll("select");
    if (_0x147110) {
      this.mediaItemContainers[_0x32da3d].classList.remove("bundle-deals__media-item--disabled");
      _0x246c21.classList.remove("bundle-deals__product--deselected");
      _0x22dce1.forEach(_0x19fa8f => {
        _0x19fa8f.removeAttribute("disabled");
      });
    } else {
      this.mediaItemContainers[_0x32da3d].classList.add("bundle-deals__media-item--disabled");
      _0x246c21.classList.add("bundle-deals__product--deselected");
      _0x22dce1.forEach(_0x20e2d7 => {
        _0x20e2d7.setAttribute("disabled", "");
      });
    }
    this.updateFormIds();
    if (this.updatePrices) {
      this.updateTotalPrice();
    }
  }
  handleSelectChange(_0x14fc3e) {
    const _0x23e775 = _0x14fc3e.currentTarget;
    const _0x497b9b = parseInt(_0x23e775.dataset.index);
    const _0xb8eaac = Array.from(_0x23e775.querySelectorAll("select"), _0xaea70 => _0xaea70.value);
    const _0x4b3aa1 = JSON.parse(_0x23e775.querySelector("[type=\"application/json\"]").textContent).filter(_0x32609b => _0x23e775.querySelector(":checked").value === _0x32609b.option1);
    const _0x4a6d52 = [..._0x23e775.querySelectorAll(".select--small")];
    updateVariantStatuses(_0x4b3aa1, _0x4a6d52);
    const _0x21fac3 = JSON.parse(_0x23e775.querySelector("[type=\"application/json\"]").textContent).find(_0x259cb8 => {
      return !_0x259cb8.options.map((_0x124e45, _0xc87b) => {
        return _0xb8eaac[_0xc87b] === _0x124e45;
      }).includes(false);
    });
    if (!_0x21fac3) {
      if (this.skipNonExistent) {
        findAvailableVariant(_0x23e775, _0xb8eaac, false, true, this.skipUnavailable);
      }
      return;
    }
    if (this.skipUnavailable && !_0x21fac3.available) {
      if (findAvailableVariant(_0x23e775, _0xb8eaac, false, true, true)) {
        return;
      }
    }
    let {
      price: _0x37a87d,
      compare_at_price: _0x43d3c1,
      featured_image: _0x1edac2
    } = _0x21fac3;
    _0x37a87d = parseInt(_0x37a87d);
    let _0x35ef0a = _0x43d3c1 ? parseInt(_0x43d3c1) : _0x37a87d;
    const _0x19c738 = _0x23e775.dataset.percentageLeft ?? 1;
    const _0x55f9ff = _0x23e775.dataset.fixedDiscount ?? 0;
    _0x37a87d = _0x37a87d * _0x19c738 - _0x55f9ff;
    _0x1edac2 &&= _0x1edac2.src;
    const _0x151401 = _0x21fac3.id;
    this.selectedVariants[_0x23e775.dataset.idIndex].id = _0x151401;
    this.selectedVariants[_0x23e775.dataset.idIndex].price = _0x37a87d;
    this.selectedVariants[_0x23e775.dataset.idIndex].comparePrice = _0x35ef0a;
    this.updateFormIds();
    if (this.updatePrices) {
      this.prices[_0x497b9b].innerHTML = this.currencySymbol + (_0x37a87d / 100).toFixed(2);
      if (_0x35ef0a > _0x37a87d) {
        this.comparePrices[_0x497b9b].innerHTML = this.currencySymbol + (_0x35ef0a / 100).toFixed(2);
      } else {
        this.comparePrices[_0x497b9b].innerHTML = "";
      }
      this.updateTotalPrice();
    }
    if (_0x1edac2 && _0x1edac2.length > 0 && this.mediaItemImgs[_0x497b9b]) {
      this.mediaItemImgs[_0x497b9b].src = _0x1edac2;
    }
  }
  updateFormIds() {
    const _0x28eac2 = [];
    const _0x4ce928 = this.selectedVariants;
    for (const _0x4d68b1 in _0x4ce928) {
      const _0x56c187 = _0x4ce928[_0x4d68b1];
      if (_0x56c187 != null && _0x56c187.checked) {
        const _0x2fdf9a = _0x28eac2.findIndex(_0x12dac9 => _0x12dac9.id === _0x56c187.id);
        if (_0x2fdf9a < 0) {
          const _0x38490d = {
            id: _0x56c187.id,
            quantity: 1
          };
          const _0xc8542 = _0x38490d;
          const _0x3cd8fb = _0xc8542;
          _0x28eac2.unshift(_0x3cd8fb);
        } else {
          _0x28eac2[_0x2fdf9a].quantity += 1;
        }
      }
    }
    this.formVariants = _0x28eac2;
  }
  updateTotalPrice() {
    const _0x827fe0 = [];
    const _0x4a4bc2 = [];
    const _0x35d0ea = this.selectedVariants;
    for (const _0x29fef6 in _0x35d0ea) {
      const _0x22aae8 = _0x35d0ea[_0x29fef6];
      if (_0x22aae8 != null && _0x22aae8.checked) {
        _0x827fe0.push(parseInt(_0x22aae8.price));
        _0x4a4bc2.push(parseInt(_0x22aae8.comparePrice));
      }
    }
    const _0x1e00b0 = _0x827fe0.reduce((_0x1e6fbe, _0x5c9eec) => _0x1e6fbe + _0x5c9eec, 0);
    const _0x1dcb6 = _0x1e00b0 * this.percentageLeft - this.fixedDiscount;
    const _0xff0136 = _0x4a4bc2.reduce((_0x5e5554, _0x5b1637) => _0x5e5554 + _0x5b1637, 0);
    this.totalPrice.innerHTML = this.currencySymbol + (_0x1dcb6 / 100).toFixed(2);
    if (_0xff0136 > _0x1dcb6) {
      this.totalComparePrice.innerHTML = this.currencySymbol + (_0xff0136 / 100).toFixed(2);
    } else {
      this.totalComparePrice.innerHTML = "";
    }
  }
}
customElements.define("bundle-deals", BundleDeals);
class QuantityBreaks extends HTMLElement {
  constructor() {
    super();
    this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section);
    this.inputs = this.querySelectorAll("input[name=\"quantity\"]");
    this.labels = this.querySelectorAll(".quantity-break");
    this.jsonData = this.querySelector("[type=\"application/json\"]");
    this.hasVariants = this.jsonData.dataset.hasVariants === "true";
    this.selectedVariants = {
      input_1: [],
      input_2: [],
      input_3: [],
      input_4: [],
      input_5: [],
      input_6: []
    };
    this.updateUnavailable = this.dataset.updateUnavailable === "true";
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    this.formVariants = [];
    this.selectedQuantity = 1;
    if (this.querySelector("input[checked]")) {
      this.selectedQuantity = parseInt(this.querySelector("input[checked]").value);
    }
    this.variantSelects = this.querySelectorAll(".quantity-break__selector-item");
    this.updatePrices = this.dataset.updatePrices === "true";
    this.moneyFormat = this.dataset.moneyFormat;
    if (this.hasVariants) {
      this.initVariants();
    }
    this.inputs.forEach(_0x1eb510 => {
      _0x1eb510.addEventListener("change", this.handleChange.bind(this));
    });
    this.variantSelects.forEach(_0x1f6eab => {
      _0x1f6eab.addEventListener("change", this.handleSelectChange.bind(this));
    });
  }
  handleSelectChange(_0x1e7775) {
    const _0x5b6224 = _0x1e7775.currentTarget;
    const _0x327cc4 = Array.from(_0x5b6224.querySelectorAll("select"), _0x14e6b0 => _0x14e6b0.value);
    if (this.updateUnavailable) {
      const _0x1d03cb = this.getVariantData().filter(_0x147ddf => _0x5b6224.querySelector(":checked").value === _0x147ddf.option1);
      const _0x2dcd38 = [..._0x5b6224.querySelectorAll(".select--small")];
      updateVariantStatuses(_0x1d03cb, _0x2dcd38);
    }
    const _0x1133c8 = this.getVariantData().find(_0xf029d8 => {
      return !_0xf029d8.options.map((_0x112da2, _0x23d000) => {
        return _0x327cc4[_0x23d000] === _0x112da2;
      }).includes(false);
    });
    if (!_0x1133c8) {
      if (this.skipNonExistent) {
        findAvailableVariant(_0x5b6224, _0x327cc4, false, true, this.skipUnavailable);
      }
      return;
    }
    if (this.skipUnavailable && !_0x1133c8.available) {
      if (findAvailableVariant(_0x5b6224, _0x327cc4, false, true, true)) {
        return;
      }
    }
    _0x5b6224.dataset.selectedId = _0x1133c8.id;
    const _0x5f5379 = _0x5b6224.dataset.selectIndex;
    const _0x2e00f5 = _0x5b6224.closest(".quantity-break");
    const _0x42999c = _0x2e00f5.dataset.input;
    this.selectedVariants[_0x42999c][_0x5f5379] = _0x1133c8.id;
    this.formVariants = this.selectedVariants[_0x42999c];
    this.updateMedia(_0x1133c8);
    if (!this.updatePrices) {
      return;
    }
    var _0x3c6973 = 0;
    var _0x8da109 = 0;
    const _0x47bdd1 = parseFloat(_0x2e00f5.dataset.quantity);
    const _0x204b17 = parseFloat(_0x2e00f5.dataset.percentageLeft);
    const _0x348198 = parseFloat(_0x2e00f5.dataset.fixedDiscount);
    for (let _0x9488a7 = 0; _0x9488a7 < _0x47bdd1; _0x9488a7++) {
      const _0x306753 = parseInt(this.selectedVariants[_0x42999c][_0x9488a7]);
      const _0x4ea8d2 = this.getVariantData().find(_0x55ce50 => parseInt(_0x55ce50.id) === _0x306753);
      if (!_0x4ea8d2) {
        return;
      }
      _0x3c6973 += _0x4ea8d2.price;
      if (_0x4ea8d2.compare_at_price && _0x4ea8d2.compare_at_price > _0x4ea8d2.price) {
        _0x8da109 += _0x4ea8d2.compare_at_price;
      } else {
        _0x8da109 += _0x4ea8d2.price;
      }
    }
    _0x3c6973 = _0x3c6973 * _0x204b17 - _0x348198;
    const _0x26bb2d = _0x8da109 - _0x3c6973;
    const _0x2b9f1a = Math.round(_0x26bb2d / 100) * 100;
    const _0x352df0 = _0x3c6973 / _0x47bdd1;
    const _0x3d49d6 = _0x8da109 / _0x47bdd1;
    const _0x343278 = formatMoney(_0x3c6973, this.moneyFormat, true);
    const _0x246ec8 = formatMoney(_0x8da109, this.moneyFormat, true);
    const _0xa51246 = formatMoney(_0x26bb2d, this.moneyFormat, true);
    const _0x43ae85 = formatMoney(_0x2b9f1a, this.moneyFormat, true);
    const _0x192046 = formatMoney(_0x352df0, this.moneyFormat, true);
    const _0x257893 = formatMoney(_0x3d49d6, this.moneyFormat, true);
    _0x2e00f5.querySelectorAll(".variant-price-update").forEach(_0x28ea9c => {
      let _0x1284d7 = _0x28ea9c.dataset.text;
      _0x1284d7 = _0x1284d7.replace("[quantity]", _0x47bdd1);
      _0x1284d7 = _0x1284d7.replace("[price]", _0x343278);
      _0x1284d7 = _0x1284d7.replace("[compare_price]", _0x246ec8);
      _0x1284d7 = _0x1284d7.replace("[amount_saved]", _0xa51246);
      _0x1284d7 = _0x1284d7.replace("[amount_saved_rounded]", _0x43ae85);
      _0x1284d7 = _0x1284d7.replace("[price_each]", _0x192046);
      _0x1284d7 = _0x1284d7.replace("[compare_price_each]", _0x257893);
      _0x28ea9c.innerHTML = _0x1284d7;
    });
    const _0x5d7494 = _0x2e00f5.querySelector(".quantity-break__compare-price");
    if (_0x5d7494) {
      if (_0x8da109 > _0x3c6973) {
        _0x5d7494.classList.remove("hidden");
      } else {
        _0x5d7494.classList.add("hidden");
      }
    }
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.jsonData.textContent);
    return this.variantData;
  }
  initVariants() {
    if (!this.hasVariants) {
      return;
    }
    this.labels.forEach(_0x43c70c => {
      if (_0x43c70c.querySelector(".quantity-break__variants")) {
        let _0x1dcba3 = [];
        _0x43c70c.querySelectorAll(".quantity-break__selector-item").forEach(_0x10f433 => {
          _0x1dcba3.push(_0x10f433.dataset.selectedId);
        });
        this.selectedVariants[_0x43c70c.dataset.input] = _0x1dcba3;
      }
    });
    this.formVariants = [];
  }
  updateMedia(_0x358016) {
    if (!_0x358016) {
      return;
    }
    if (!_0x358016.featured_media) {
      return;
    }
    const _0xd0be93 = document.querySelectorAll("[id^=\"MediaGallery-" + this.dataset.section + "\"]");
    _0xd0be93.forEach(_0xdea139 => _0xdea139.setActiveMedia(this.dataset.section + "-" + _0x358016.featured_media.id, true));
  }
  handleChange(_0x1cb7c6) {
    const _0xf824d2 = parseInt(_0x1cb7c6.target.value);
    this.selectedQuantity = _0xf824d2;
    if (this.hasVariants) {
      this.formVariants = this.selectedVariants[_0x1cb7c6.target.dataset.input];
    }
    if (this.quantityGifts) {
      this.quantityGifts.unlockGifts(_0xf824d2);
    }
  }
}
customElements.define("quantity-breaks", QuantityBreaks);
function updateVariantStatuses(_0x41c8fc, _0x19a97a) {
  _0x19a97a.forEach((_0x1253c3, _0x2b06eb) => {
    if (_0x2b06eb === 0) {
      return;
    }
    const _0x33268d = [..._0x1253c3.querySelectorAll("option")];
    const _0x49d7f4 = _0x19a97a[_0x2b06eb - 1].querySelector(":checked").value;
    const _0x10732a = _0x41c8fc.filter(_0x14a5df => _0x14a5df.available && _0x14a5df["option" + _0x2b06eb] === _0x49d7f4).map(_0x50c55a => _0x50c55a["option" + (_0x2b06eb + 1)]);
    const _0x306dc2 = _0x41c8fc.filter(_0x30e972 => _0x30e972["option" + _0x2b06eb] === _0x49d7f4).map(_0x5778f1 => _0x5778f1["option" + (_0x2b06eb + 1)]);
    _0x33268d.forEach(_0x2d5a88 => {
      _0x2d5a88.classList.remove("unavailable", "non-existent");
      if (_0x306dc2.includes(_0x2d5a88.getAttribute("value"))) {
        if (_0x10732a.includes(_0x2d5a88.getAttribute("value"))) {
          _0x2d5a88.innerText = _0x2d5a88.getAttribute("value");
        } else {
          _0x2d5a88.innerText = window.variantStrings.unavailable_with_option.replace("[value]", _0x2d5a88.getAttribute("value"));
          _0x2d5a88.classList.add("unavailable");
        }
      } else {
        _0x2d5a88.innerText = window.variantStrings.unavailable_with_option.replace("[value]", _0x2d5a88.getAttribute("value"));
        _0x2d5a88.classList.add("non-existent");
      }
    });
  });
}
function findAvailableVariant(_0x42a1a5, _0x58e9ce, _0x219681 = true, _0x3be060 = false, _0x4d807c = false) {
  for (let _0x2b4297 = _0x58e9ce.length - 1; _0x2b4297 >= 0; _0x2b4297--) {
    const _0x2ded94 = _0x219681 ? _0x42a1a5.querySelector(".product-form__input:nth-child(" + (_0x2b4297 + 1) + ")") : _0x42a1a5.querySelectorAll(".select")[_0x2b4297];
    const _0x28fd8b = _0x219681 ? _0x2ded94.querySelector(".product-form__input__type").dataset.type : "dropdown";
    const _0x339f87 = _0x28fd8b === "dropdown" ? _0x2ded94.querySelectorAll("option") : _0x2ded94.querySelectorAll("input[type=\"radio\"]");
    let _0x5f1160 = Array.from(_0x339f87).findIndex(_0x42979e => _0x42979e.value === _0x58e9ce[_0x2b4297]);
    let _0x87ceca = false;
    while (_0x5f1160 < _0x339f87.length - 1) {
      _0x5f1160++;
      const _0x26928f = _0x339f87[_0x5f1160];
      if ((!_0x3be060 || !_0x26928f.classList.contains("non-existent")) && (!_0x4d807c || !_0x26928f.classList.contains("unavailable"))) {
        _0x58e9ce[_0x2b4297] = _0x26928f.value;
        _0x87ceca = true;
        break;
      }
    }
    if (!_0x87ceca) {
      _0x5f1160 = Array.from(_0x339f87).findIndex(_0x823148 => _0x823148.value === _0x58e9ce[_0x2b4297]);
      while (_0x5f1160 > 0) {
        _0x5f1160--;
        const _0x522389 = _0x339f87[_0x5f1160];
        if ((!_0x3be060 || !_0x522389.classList.contains("non-existent")) && (!_0x4d807c || !_0x522389.classList.contains("unavailable"))) {
          _0x58e9ce[_0x2b4297] = _0x522389.value;
          _0x87ceca = true;
          break;
        }
      }
    }
    if (_0x87ceca) {
      if (_0x28fd8b === "dropdown") {
        _0x2ded94.querySelector(".select__select").value = _0x58e9ce[_0x2b4297];
      } else {
        _0x2ded94.querySelector("input[type=\"radio\"][value=\"" + _0x58e9ce[_0x2b4297] + "\"]").checked = true;
      }
      _0x42a1a5.dispatchEvent(new Event("change"));
      return true;
    }
  }
  return false;
}
class QuantityGifts extends HTMLElement {
  constructor() {
    super();
    this.gifts = this.querySelectorAll(".quantity-gift");
    this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
    this.quantitySelector = document.getElementById("Quantity-Form--" + this.dataset.section);
    this.unlockedItems = [];
    this.mainProduct = this.dataset.mainProduct;
    this.cartItems = document.querySelector("cart-drawer-items");
    this.initUnlock();
  }
  initUnlock() {
    let _0x2db3a4 = 1;
    const _0x2e3f83 = this.mainProduct ? document.querySelectorAll(".cart-item--product-" + this.mainProduct) : null;
    if (_0x2e3f83 && _0x2e3f83.length) {
      _0x2db3a4 = 0;
      for (let _0x518739 = 0; _0x518739 < _0x2e3f83.length; _0x518739++) {
        _0x2db3a4 += parseInt(_0x2e3f83[_0x518739].dataset.quantity);
      }
    } else if (this.quantityBreaks) {
      _0x2db3a4 = parseInt(this.quantityBreaks.selectedQuantity);
    } else if (this.quantitySelector) {
      const _0x255852 = this.quantitySelector.querySelector("input[name=\"quantity\"]");
      _0x2db3a4 = parseInt(_0x255852.value);
    }
    this.unlockGifts(_0x2db3a4, true);
  }
  unlockGifts(_0x3fb291, _0x46afc6 = false) {
    this.unlockedItems = [];
    this.gifts.forEach(_0x1c83f4 => {
      if (parseInt(_0x1c83f4.dataset.quantity) <= _0x3fb291) {
        _0x1c83f4.classList.add("quantity-gift--unlocked");
        _0x1c83f4.dataset.unlocked = "true";
        const _0x3541a6 = document.querySelector(".cart-item--product-" + _0x1c83f4.dataset.handle);
        if (_0x1c83f4.dataset.product && !_0x3541a6) {
          this.unlockedItems.unshift(_0x1c83f4.dataset.product);
        }
      } else {
        _0x1c83f4.classList.remove("quantity-gift--unlocked");
        _0x1c83f4.dataset.unlocked = "false";
      }
    });
    if (this.mainProduct && _0x46afc6) {
      this.addRemoveProducts();
    }
  }
  addRemoveProducts() {
    if (!this.mainProduct) {
      return;
    }
    const _0x117fe4 = document.querySelectorAll(".cart-item--product-" + this.mainProduct);
    this.gifts.forEach(_0x5126f6 => {
      if (_0x117fe4.length) {
        if (_0x5126f6.dataset.unlocked === "true" && _0x5126f6.dataset.product) {
          this.addToCart(_0x5126f6);
        } else {
          this.removeFromCart(_0x5126f6);
        }
      } else {
        this.removeFromCart(_0x5126f6);
      }
    });
  }
  addToCart(_0x4513be) {
    const _0x4cf261 = document.querySelector(".cart-item--product-" + _0x4513be.dataset.handle);
    if (_0x4cf261) {
      return;
    }
    const _0xe2f3e0 = _0x4513be.querySelector("product-form");
    if (_0xe2f3e0) {
      _0xe2f3e0.handleSubmit();
    }
  }
  removeFromCart(_0x38ac1b) {
    const _0x5ac095 = document.querySelector(".cart-item--product-" + _0x38ac1b.dataset.handle);
    if (!_0x5ac095 || !this.cartItems) {
      return;
    }
    this.cartItems.updateQuantity(_0x5ac095.dataset.index, 0);
  }
}
customElements.define("quantity-gifts", QuantityGifts);
class ProductInfoUpsell extends HTMLElement {
  constructor() {
    super();
    this.image = this.querySelector(".upsell__image__img");
    this.toggleBtn = this.querySelector(".upsell-toggle-btn");
    this.variantSelects = this.querySelector(".upsell__variant-picker");
    this.variantSelectElements = this.querySelectorAll(".select__select");
    this.jsonData = this.querySelector("[type=\"application/json\"]");
    this.productForm = this.querySelector("product-form");
    if (this.productForm) {
      this.idInput = this.productForm.querySelector("[name=\"id\"]");
    }
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    this.updatePrices = this.dataset.updatePrices === "true";
    if (this.updatePrices) {
      this.price = parseInt(this.dataset.price);
      this.comparePrice = parseInt(this.dataset.comparePrice);
      this.priceSpan = this.querySelector(".upsell__price .regular-price");
      this.comparePriceSpan = this.querySelector(".upsell__price .compare-price");
      this.percentageLeft = parseFloat(this.dataset.percentageLeft);
      this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
      this.moneyFormat = this.dataset.moneyFormat;
      this.isMainOfferItem = this.dataset.mainOfferItem === "true";
      if (this.isMainOfferItem) {
        this.mainOfferContainer = document.querySelector("#MainBundleOffer-" + this.dataset.section);
      }
    }
    if (this.toggleBtn) {
      this.toggleBtn.addEventListener("click", this.handleToggle.bind(this));
    }
    if (this.variantSelects) {
      this.variantSelects.addEventListener("change", this.handleSelectChange.bind(this));
    }
  }
  handleToggle(_0x194f95) {
    if (_0x194f95.target.nodeName.toLowerCase() === "select" || _0x194f95.target.nodeName.toLowerCase() === "option") {
      return;
    }
    if (this.dataset.selected === "true") {
      this.dataset.selected = "false";
    } else {
      this.dataset.selected = "true";
    }
  }
  handleSelectChange(_0x707617) {
    const _0x2567e6 = _0x707617.currentTarget;
    const _0x29b3bc = Array.from(_0x2567e6.querySelectorAll("select"), _0x5cbcfb => _0x5cbcfb.value);
    const _0x4d4b05 = this.getVariantData().find(_0x49cd3e => {
      return !_0x49cd3e.options.map((_0x36a4d8, _0x34993b) => {
        return _0x29b3bc[_0x34993b] === _0x36a4d8;
      }).includes(false);
    });
    const _0x3208ec = this.getVariantData().filter(_0x51d816 => _0x2567e6.querySelector(":checked").value === _0x51d816.option1);
    const _0xd99d05 = [..._0x2567e6.querySelectorAll("select")];
    updateVariantStatuses(_0x3208ec, _0xd99d05);
    if (!_0x4d4b05) {
      if (this.skipNonExistent) {
        findAvailableVariant(_0x2567e6, _0x29b3bc, false, true, this.skipUnavailable);
      }
      return;
    }
    if (this.skipUnavailable && !_0x4d4b05.available) {
      if (findAvailableVariant(_0x2567e6, _0x29b3bc, false, true, true)) {
        return;
      }
    }
    if (this.updatePrices) {
      this.price = _0x4d4b05.price * this.percentageLeft - this.fixedDiscount;
      this.comparePrice = _0x4d4b05.price;
      if (_0x4d4b05.compare_at_price && _0x4d4b05.compare_at_price > _0x4d4b05.price) {
        this.comparePrice = _0x4d4b05.compare_at_price;
      }
      displayPrices(this.price, this.comparePrice, this.priceSpan, this.comparePriceSpan, this.moneyFormat);
    }
    if (this.image && _0x4d4b05.featured_image) {
      this.image.src = _0x4d4b05.featured_image.src;
    }
    this.updateId(_0x4d4b05.id);
    if (this.isMainOfferItem && this.mainOfferContainer.updateTotalPrices) {
      this.mainOfferContainer.updateTotalPrices();
    }
  }
  updateId(_0x5b02a7) {
    this.dataset.id = _0x5b02a7;
    if (this.idInput) {
      this.idInput.value = _0x5b02a7;
    }
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.jsonData.textContent);
    return this.variantData;
  }
}
customElements.define("product-info-upsell", ProductInfoUpsell);
class CartDrawerUpsell extends ProductInfoUpsell {
  constructor() {
    super();
    this.cartDrawer = document.querySelector("cart-drawer");
    this.cartItems = this.cartDrawer.querySelector("cart-drawer-items");
    this.classicAddButton = this.querySelector(".upsell__add-btn");
  }
  handleToggle(_0x4ac808) {
    if (_0x4ac808.target.nodeName.toLowerCase() === "select" || _0x4ac808.target.nodeName.toLowerCase() === "option") {
      return;
    }
    if (this.dataset.selected === "true") {
      this.dataset.selected = "false";
      this.removeFromCart();
    } else {
      this.dataset.selected = "true";
      this.addToCart();
    }
  }
  addRemoveFromCart() {
    if (this.dataset.selected === "true" && !this.cartDrawer.classList.contains("is-empty")) {
      this.addToCart();
    } else {
      this.removeFromCart();
    }
  }
  addToCart() {
    const _0x5e1dfa = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    if (_0x5e1dfa) {
      return;
    }
    if (this.toggleBtn) {
      this.toggleBtn.setAttribute("disabled", "");
    }
    this.variantSelectElements.forEach(_0x3037b4 => {
      _0x3037b4.setAttribute("disabled", "");
    });
    this.productForm.handleSubmit();
  }
  removeFromCart() {
    const _0x465fbf = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    if (!_0x465fbf || !this.cartItems) {
      return;
    }
    if (this.toggleBtn) {
      this.toggleBtn.setAttribute("disabled", "");
    }
    this.variantSelectElements.forEach(_0x2af015 => {
      _0x2af015.setAttribute("disabled", "");
    });
    this.cartItems.updateQuantity(_0x465fbf.dataset.index, 0);
  }
  updateId(_0x49429e) {
    this.dataset.id = _0x49429e;
    this.idInput.value = _0x49429e;
    if (this.classicAddButton) {
      return;
    }
    if (this.dataset.selected === "true") {
      if (this.selectTimeout) {
        clearTimeout(this.selectTimeout);
      }
      this.removeFromCart();
      const _0x5a5ed3 = _0x34b7b6 => {
        if (_0x34b7b6.detail.handle === "handle") {
          this.addToCart();
          document.removeEventListener("cartQuantityUpdated", _0x5a5ed3);
        }
      };
      document.addEventListener("cartQuantityUpdated", _0x5a5ed3);
    }
  }
  getUpdateRequired() {
    const _0x244ec3 = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    let _0x409143 = false;
    if (_0x244ec3 && this.dataset.selected === "false") {
      _0x409143 = true;
    } else if (!_0x244ec3 && this.dataset.selected === "true") {
      _0x409143 = true;
    }
    return _0x409143;
  }
}
customElements.define("cart-drawer-upsell", CartDrawerUpsell);
function displayPrices(_0x11488, _0x1535b5, _0x5ef89c, _0x3de83d, _0xc3d1b) {
  if (!_0xc3d1b) {
    return;
  }
  if (_0x11488 && _0x5ef89c) {
    var _0x35c383 = formatMoney(_0x11488, _0xc3d1b);
    _0x5ef89c.innerHTML = _0x35c383;
  }
  if (_0x1535b5 && _0x3de83d) {
    var _0x26d864 = formatMoney(_0x1535b5, _0xc3d1b);
    _0x3de83d.innerHTML = _0x26d864;
    if (_0x1535b5 > _0x11488) {
      _0x3de83d.classList.remove("hidden");
    } else {
      _0x3de83d.classList.add("hidden");
    }
  }
}
function formatMoney(_0x7d61e5, _0x118701, _0x32996d = false) {
  if (typeof _0x7d61e5 == "string") {
    _0x7d61e5 = _0x7d61e5.replace(".", "");
  }
  var _0x2dbcf = "";
  var _0x460f3c = /\{\{\s*(\w+)\s*\}\}/;
  var _0x3edcf5 = _0x118701;
  function _0xe80386(_0x1a35a7, _0x551d6a) {
    if (typeof _0x1a35a7 == "undefined") {
      return _0x551d6a;
    } else {
      return _0x1a35a7;
    }
  }
  function _0x1f800f(_0x46d814, _0x1638f3, _0x7b7391, _0x569c6a) {
    _0x1638f3 = _0xe80386(_0x1638f3, 2);
    _0x7b7391 = _0xe80386(_0x7b7391, ",");
    _0x569c6a = _0xe80386(_0x569c6a, ".");
    if (isNaN(_0x46d814) || _0x46d814 == null) {
      return 0;
    }
    _0x46d814 = (_0x46d814 / 100).toFixed(_0x1638f3);
    var _0x4b07bc = _0x46d814.split(".");
    var _0x4d1523 = _0x4b07bc[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + _0x7b7391);
    var _0x355454 = _0x4b07bc[1] ? _0x569c6a + _0x4b07bc[1] : "";
    if (_0x32996d && _0x355454 === _0x569c6a + "00") {
      _0x355454 = "";
    }
    return _0x4d1523 + _0x355454;
  }
  switch (_0x3edcf5.match(_0x460f3c)[1]) {
    case "amount":
      _0x2dbcf = _0x1f800f(_0x7d61e5, 2);
      break;
    case "amount_no_decimals":
      _0x2dbcf = _0x1f800f(_0x7d61e5, 0);
      break;
    case "amount_with_comma_separator":
      _0x2dbcf = _0x1f800f(_0x7d61e5, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      _0x2dbcf = _0x1f800f(_0x7d61e5, 0, ".", ",");
      break;
  }
  return _0x3edcf5.replace(_0x460f3c, _0x2dbcf);
}
class CartDrawerGift extends CartDrawerUpsell {
  constructor() {
    super();
  }
}
customElements.define("cart-drawer-gift", CartDrawerGift);
function initToggleUpsells() {
  const _0x2b3940 = document.querySelector("cart-drawer");
  if (_0x2b3940) {
    _0x2b3940.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift").forEach(_0x3cd395 => {
      if (_0x3cd395.addRemoveFromCart) {
        _0x3cd395.addRemoveFromCart();
      }
    });
  }
}
initToggleUpsells();
class MainBundleOffer extends HTMLElement {
  constructor() {
    super();
    this.offerItems = this.querySelectorAll(".main-offer-item");
    this.updatePrices = this.dataset.updatePrices === "true";
    if (this.updatePrices) {
      this.priceSpan = this.querySelector(".bundle-deals__total-price-js");
      this.comparePriceSpan = this.querySelector(".bundle-deals__total-compare-price-js");
      this.percentageLeft = parseFloat(this.dataset.percentageLeft);
      this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
      this.moneyFormat = this.dataset.moneyFormat;
    }
  }
  updateTotalPrices() {
    if (!this.updatePrices) {
      return;
    }
    var _0x22ca52 = 0;
    var _0x86bb57 = 0;
    for (let _0x426882 = 0; _0x426882 < this.offerItems.length; _0x426882++) {
      _0x22ca52 += parseInt(this.offerItems[_0x426882].price);
      _0x86bb57 += parseInt(this.offerItems[_0x426882].comparePrice);
    }
    _0x22ca52 = _0x22ca52 * this.percentageLeft - this.fixedDiscount;
    displayPrices(_0x22ca52, _0x86bb57, this.priceSpan, this.comparePriceSpan, this.moneyFormat);
  }
}
customElements.define("main-bundle-offer", MainBundleOffer);
class CustomProductField extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.fieldName = this.dataset.name;
    this.input = this.querySelector("[type=\"text\"], [type=\"number\"], textarea");
    this.inputRadios = this.querySelectorAll("[type=\"radio\"]");
    this.select = this.querySelector(".select__select");
    this.productForm = document.getElementById("product-form-" + this.dataset.section);
    this.prevValue = this.dataset.defaultValue;
    this.isRequired = this.dataset.required === "true";
    this.isText = true;
    this.notMain = this.dataset.notMain === "true";
    if (this.dataset.type === "select" || this.dataset.type === "pills") {
      this.isText = false;
    }
    this.createInputs();
    if (this.isRequired && this.isText) {
      this.isValid = true;
      this.atcButtons = this.notMain ? document.querySelectorAll(".featured-product-atc-" + this.dataset.section) : document.querySelectorAll(".main-product-atc");
      this.mainAtcButton = this.productForm.querySelector("#ProductSubmitButton-" + this.dataset.section);
      this.mainAtcBtnLabel = this.mainAtcButton.querySelector(".main-atc__label");
      this.mainAtcBtnError = this.mainAtcButton.querySelector(".main-atc__error");
      this.atcErrorMsg = this.dataset.atcErrorMsg;
      this.mainAtcButton.dataset.requiredFields = parseInt(this.mainAtcButton.dataset.requiredFields) + 1;
      this.mainAtcBtnError.innerHTML = this.atcErrorMsg;
      this.applyStickyAtcError = this.dataset.applyStickyAtcError === "true";
      this.stickyAtcButton = document.querySelector("#sticky-atc-" + this.dataset.section);
      if (this.applyStickyAtcError && this.stickyAtcButton) {
        this.stickyAtcBtnLabel = this.stickyAtcButton.querySelector(".sticky-atc__label");
        this.stickyAtcBtnError = this.stickyAtcButton.querySelector(".sticky-atc__error");
        this.stickyAtcBtnError.innerHTML = this.atcErrorMsg;
      }
      this.validateValue(this.prevValue, null);
    }
    if (this.input) {
      this.input.addEventListener("input", this.handleChange.bind(this));
    }
    this.inputRadios.forEach(_0x4e7244 => {
      _0x4e7244.addEventListener("input", this.handleChange.bind(this));
    });
    if (this.select) {
      this.select.addEventListener("change", this.handleChange.bind(this));
    }
  }
  handleChange(_0x2054ed) {
    const _0x58eea6 = _0x2054ed.target.value.trim();
    if (_0x2054ed.target.checkValidity()) {
      this.prevValue = _0x58eea6;
    } else {
      _0x2054ed.target.value = this.prevValue;
      return;
    }
    this.dataset.value = _0x58eea6;
    this.productFormInput.value = _0x58eea6;
    if (this.isRequired && this.isText) {
      this.validateValue(_0x58eea6, _0x2054ed.target);
    }
  }
  validateValue(_0x266806, _0x17c1e4) {
    const _0x23b40e = _0x266806.length > 0 ? true : false;
    if (_0x23b40e === this.isValid) {
      return;
    }
    this.isValid = _0x23b40e;
    if (_0x17c1e4) {
      if (this.isValid) {
        _0x17c1e4.classList.remove("input--error");
        this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) + 1;
      } else {
        _0x17c1e4.classList.add("input--error");
        this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) - 1;
      }
    }
    const _0x2bdb4b = this.mainAtcButton.dataset.validFields === this.mainAtcButton.dataset.requiredFields;
    const _0x16cc94 = this.mainAtcButton.dataset.unavailable === "true";
    this.atcButtons.forEach(_0x5760c1 => {
      if (_0x2bdb4b && !_0x16cc94) {
        _0x5760c1.removeAttribute("disabled");
      } else {
        _0x5760c1.setAttribute("disabled", "");
      }
    });
    if (this.atcErrorMsg.length === 0) {
      return;
    }
    if (_0x2bdb4b) {
      this.mainAtcBtnLabel.style.display = "";
      this.mainAtcBtnError.style.display = "none";
      if (this.applyStickyAtcError && this.stickyAtcButton) {
        this.stickyAtcBtnLabel.style.display = "";
        this.stickyAtcBtnError.style.display = "none";
      }
    } else {
      this.mainAtcBtnLabel.style.display = "none";
      this.mainAtcBtnError.style.display = "";
      if (this.applyStickyAtcError && this.stickyAtcButton) {
        this.stickyAtcBtnLabel.style.display = "none";
        this.stickyAtcBtnError.style.display = "";
      }
    }
  }
  createInputs() {
    this.productFormInput = document.createElement("input");
    this.productFormInput.setAttribute("type", "hidden");
    this.productFormInput.setAttribute("name", "properties[" + this.fieldName + "]");
    this.productFormInput.value = this.dataset.defaultValue;
    this.productFormInput.classList.add("theme-property-input");
    this.productForm.appendChild(this.productFormInput);
  }
}
customElements.define("custom-product-field", CustomProductField);
function playMedia() {
  if (!serial) {
    serial = document.currentScript.dataset.animationsType || "";
  }
}
class ThemeSubscriptionWidget extends HTMLElement {
  constructor() {
    super();
    this.isToggle = this.dataset.isToggle === "true";
    this.isCheckbox = this.dataset.isCheckbox === "true";
  }
  connectedCallback() {
    this.sectionId = this.dataset.section;
    this.productForm = document.getElementById("product-form-" + this.sectionId);
    this.oneTimeBox = this.querySelector("[data-type=\"one_time\"]");
    this.subscriptionBox = this.querySelector("[data-type=\"subscription\"]");
    if (this.isToggle) {
      this.toggleOptions = this.querySelectorAll(".subscription__toggle-option");
      this.frequencyContainer = this.querySelector(".subscription__toggle-frequency");
    }
    this.frequencyDropdown = this.querySelector("#SubscriptionFrequency-" + this.sectionId);
    this.frequencyRadios = this.querySelectorAll(".subscription__frequency-input");
    this.subPriceElements = this.querySelectorAll(".sub-price-update");
    this.oneTimePriceElements = this.querySelectorAll(".one-time-price-update");
    this.selectedPlanId = this.dataset.firstSellingPlanId;
    this.isSubSelected = this.dataset.preselected === "subscription";
    this.basePrice = parseInt(this.dataset.basePrice);
    this.baseComparePrice = parseInt(this.dataset.baseComparePrice);
    this.subscriptionName = this.dataset.subscriptionName;
    this.updatePrices = this.dataset.updatePrices === "true";
    this.discountType = this.dataset.discountType;
    this.discountValue = parseInt(this.dataset.discountValue);
    this.moneyFormat = this.dataset.moneyFormat;
    this.sellingPlanInput = null;
    this.storeOriginalTemplates();
    this.quantityBreaks = document.getElementById("quantity-breaks-" + this.sectionId);
    if (this.quantityBreaks) {
      const _0x536baf = this.quantityBreaks.querySelectorAll("input[name=\"quantity\"]");
      _0x536baf.forEach(_0x4c4890 => {
        _0x4c4890.addEventListener("change", () => {
          this.handleQuantityChange();
        });
      });
      document.addEventListener("variant:change", _0x2e34ee => {
        this.handleVariantChange(_0x2e34ee);
      });
    }
    this.init();
  }
  storeOriginalTemplates() {
    if (this.isToggle) {
      const _0x364e9a = this.querySelector(".subscription__toggle-option[data-type=\"subscription\"]");
      const _0x179f8d = this.querySelector(".subscription__toggle-option[data-type=\"one_time\"]");
      if (_0x364e9a) {
        const _0x6d885a = _0x364e9a.querySelector(".subscription__toggle-label");
        if (_0x6d885a) {
          this.subPriceTemplate = _0x6d885a.innerHTML;
        }
      }
      if (_0x179f8d) {
        const _0x44e315 = _0x179f8d.querySelector(".subscription__toggle-label");
        if (_0x44e315) {
          this.oneTimePriceTemplate = _0x44e315.innerHTML;
        }
      }
    } else {
      if (this.oneTimeBox) {
        const _0x5bd57a = this.oneTimeBox.querySelector(".subscription__price");
        if (_0x5bd57a) {
          this.oneTimePriceTemplate = _0x5bd57a.innerHTML;
        }
        const _0x587ed9 = this.oneTimeBox.querySelector(".subscription__compare-price");
        if (_0x587ed9) {
          this.oneTimeComparePriceTemplate = _0x587ed9.innerHTML;
        }
      }
      if (this.subscriptionBox) {
        const _0x2a92ea = this.subscriptionBox.querySelector(".subscription__price");
        if (_0x2a92ea) {
          this.subPriceTemplate = _0x2a92ea.innerHTML;
        }
        const _0x1a3bbe = this.subscriptionBox.querySelector(".subscription__compare-price");
        if (_0x1a3bbe) {
          this.subComparePriceTemplate = _0x1a3bbe.innerHTML;
        }
        const _0x2c89f9 = this.subscriptionBox.querySelector(".subscription__badge");
        if (_0x2c89f9) {
          this.subBadgeTemplate = _0x2c89f9.innerHTML;
        }
      }
    }
  }
  init() {
    this.createSellingPlanInput();
    this.setupBoxClickListeners();
    this.setupFrequencyListeners();
    if (this.isToggle) {
      this.updateFrequencyVisibility();
    }
    if (this.updatePrices) {
      this.updateAllPrices();
    }
  }
  handleVariantChange(_0x47d6fc) {
    if (_0x47d6fc.detail && _0x47d6fc.detail.variant) {
      this.basePrice = _0x47d6fc.detail.variant.price;
      this.baseComparePrice = _0x47d6fc.detail.variant.compare_at_price || _0x47d6fc.detail.variant.price;
      this.dataset.basePrice = this.basePrice;
      this.dataset.baseComparePrice = this.baseComparePrice;
      if (this.updatePrices) {
        this.updateAllPrices();
      }
    }
  }
  createSellingPlanInput() {
    if (!this.productForm) {
      return;
    }
    this.sellingPlanInput = this.productForm.querySelector("input[name=\"selling_plan\"]");
    if (!this.sellingPlanInput) {
      this.sellingPlanInput = document.createElement("input");
      this.sellingPlanInput.type = "hidden";
      this.sellingPlanInput.name = "selling_plan";
      this.productForm.appendChild(this.sellingPlanInput);
    }
    this.sellingPlanInput.value = this.isSubSelected ? this.selectedPlanId : "";
  }
  setupBoxClickListeners() {
    if (this.isToggle) {
      this.toggleOptions.forEach(_0xbc7d75 => {
        _0xbc7d75.addEventListener("click", _0x259ce9 => {
          const _0x36fdf3 = _0xbc7d75.dataset.type;
          if (_0x36fdf3 === "subscription") {
            this.selectSubscription();
          } else {
            this.selectOneTime();
          }
        });
      });
    } else {
      if (this.oneTimeBox) {
        this.oneTimeBox.addEventListener("click", _0x236bae => {
          if (_0x236bae.target.closest(".subscription__frequency")) {
            return;
          }
          this.selectOneTime();
        });
      }
      if (this.subscriptionBox) {
        this.subscriptionBox.addEventListener("click", _0x885dc6 => {
          if (_0x885dc6.target.closest(".subscription__frequency")) {
            return;
          }
          this.selectSubscription();
        });
      }
    }
  }
  selectOneTime() {
    this.isSubSelected = false;
    if (this.isToggle) {
      this.toggleOptions.forEach(_0x46155c => {
        _0x46155c.classList.remove("subscription__toggle-option--selected");
        _0x46155c.dataset.selected = "false";
      });
      const _0x320fb3 = this.querySelector(".subscription__toggle-option[data-type=\"one_time\"]");
      if (_0x320fb3) {
        _0x320fb3.classList.add("subscription__toggle-option--selected");
        _0x320fb3.dataset.selected = "true";
      }
      this.updateFrequencyVisibility();
    } else if (this.isCheckbox) {
      this.subscriptionBox.classList.remove("subscription__box--selected");
      this.subscriptionBox.dataset.selected = "false";
    } else {
      if (this.oneTimeBox) {
        this.oneTimeBox.classList.add("subscription__box--selected");
        this.oneTimeBox.dataset.selected = "true";
      }
      this.subscriptionBox.classList.remove("subscription__box--selected");
      this.subscriptionBox.dataset.selected = "false";
    }
    if (this.sellingPlanInput) {
      this.sellingPlanInput.value = "";
    }
    if (this.updatePrices) {
      this.updateAllPrices();
    }
  }
  selectSubscription() {
    if (this.isToggle) {
      this.isSubSelected = true;
      this.toggleOptions.forEach(_0x500a93 => {
        _0x500a93.classList.remove("subscription__toggle-option--selected");
        _0x500a93.dataset.selected = "false";
      });
      const _0x2f507c = this.querySelector(".subscription__toggle-option[data-type=\"subscription\"]");
      if (_0x2f507c) {
        _0x2f507c.classList.add("subscription__toggle-option--selected");
        _0x2f507c.dataset.selected = "true";
      }
      this.updateFrequencyVisibility();
    } else if (this.isCheckbox) {
      this.isSubSelected = !this.isSubSelected;
      this.subscriptionBox.classList.toggle("subscription__box--selected");
      this.subscriptionBox.dataset.selected = this.isSubSelected;
    } else {
      this.isSubSelected = true;
      if (this.oneTimeBox) {
        this.oneTimeBox.classList.remove("subscription__box--selected");
        this.oneTimeBox.dataset.selected = "false";
      }
      this.subscriptionBox.classList.add("subscription__box--selected");
      this.subscriptionBox.dataset.selected = "true";
    }
    if (this.sellingPlanInput) {
      this.sellingPlanInput.value = this.isSubSelected ? this.selectedPlanId : "";
    }
    if (this.updatePrices) {
      this.updateAllPrices();
    }
  }
  updateFrequencyVisibility() {
    if (!this.isToggle || !this.frequencyContainer) {
      return;
    }
    if (this.isSubSelected) {
      this.frequencyContainer.style.display = "block";
      this.frequencyContainer.classList.remove("hidden");
    } else {
      this.frequencyContainer.style.display = "none";
      this.frequencyContainer.classList.add("hidden");
    }
  }
  setupFrequencyListeners() {
    if (this.frequencyDropdown) {
      this.frequencyDropdown.addEventListener("change", _0x12d6aa => {
        const _0x427aff = _0x12d6aa.target.selectedOptions[0];
        if (_0x427aff) {
          this.applyFrequencyChange(_0x427aff);
        }
      });
    }
    this.frequencyRadios.forEach(_0x1a08b4 => {
      _0x1a08b4.addEventListener("change", _0x22df92 => {
        if (_0x22df92.target.checked) {
          this.applyFrequencyChange(_0x22df92.target);
        }
      });
    });
  }
  applyFrequencyChange(_0x1ac6ca) {
    this.selectedPlanId = _0x1ac6ca.dataset.sellingPlanId;
    this.discountType = _0x1ac6ca.dataset.discountType || this.discountType;
    this.discountValue = _0x1ac6ca.dataset.discountValue ? parseInt(_0x1ac6ca.dataset.discountValue, 10) : this.discountValue;
    if (this.isSubSelected && this.sellingPlanInput) {
      this.sellingPlanInput.value = this.selectedPlanId;
    }
    if (this.updatePrices) {
      this.updateAllPrices();
    }
  }
  updateAllPrices() {
    this.basePrice = parseInt(this.dataset.basePrice);
    this.baseComparePrice = parseInt(this.dataset.baseComparePrice);
    if (this.quantityBreaks) {
      this.updateQuantityBreakPrices();
      const _0x16ffd4 = this.quantityBreaks.querySelector("input[name=\"quantity\"]:checked");
      if (_0x16ffd4) {
        const _0x3d839d = this.quantityBreaks.querySelector("label[data-input=\"" + _0x16ffd4.dataset.input + "\"]");
        if (_0x3d839d) {
          const _0x3d16de = parseInt(_0x16ffd4.value);
          const _0x4198ab = parseFloat(_0x3d839d.dataset.percentageLeft || 1);
          const _0x5b5e59 = parseInt(_0x3d839d.dataset.fixedDiscount || 0);
          let _0x2bce5d = Math.round(this.basePrice * _0x3d16de * _0x4198ab) - _0x5b5e59;
          let _0x263a80 = this.baseComparePrice * _0x3d16de;
          this.currentOneTimePrice = _0x2bce5d;
          this.currentQuantityBreakComparePrice = _0x263a80;
          let _0x1b0291 = _0x2bce5d;
          if (this.isSubSelected) {
            const _0x277fea = this.getSubscriptionPricePerItem();
            _0x1b0291 = Math.round(_0x277fea * _0x3d16de * _0x4198ab) - _0x5b5e59;
          }
          this.currentQuantityBreakPrice = _0x1b0291;
          this.updatePdpPrices(_0x1b0291, _0x263a80);
        }
      } else {
        this.currentOneTimePrice = this.basePrice;
        this.currentQuantityBreakComparePrice = this.baseComparePrice;
        let _0x4a661a = this.basePrice;
        if (this.isSubSelected) {
          _0x4a661a = this.getSubscriptionPricePerItem();
        }
        this.currentQuantityBreakPrice = _0x4a661a;
        this.updatePdpPrices(_0x4a661a, this.baseComparePrice);
      }
    } else {
      this.currentOneTimePrice = this.basePrice;
      this.currentQuantityBreakComparePrice = this.baseComparePrice;
      let _0x48bacd = this.basePrice;
      if (this.isSubSelected) {
        _0x48bacd = this.getSubscriptionPricePerItem();
      }
      this.currentQuantityBreakPrice = _0x48bacd;
      this.updatePdpPrices(_0x48bacd, this.baseComparePrice);
    }
    this.updateSubscriptionWidgetPrices();
  }
  getSubscriptionPricePerItem() {
    if (this.frequencyDropdown) {
      const _0x316ce0 = this.frequencyDropdown.selectedOptions[0];
      if (_0x316ce0 && _0x316ce0.dataset.price) {
        return parseInt(_0x316ce0.dataset.price);
      }
    }
    const _0x4c71c8 = this.querySelector(".subscription__frequency-input:checked");
    if (_0x4c71c8 && _0x4c71c8.dataset.price) {
      return parseInt(_0x4c71c8.dataset.price);
    }
    return this.applySubTo(this.basePrice, true);
  }
  updateQuantityBreakPrices() {
    if (!this.quantityBreaks) {
      return;
    }
    const _0x10a050 = this.quantityBreaks.querySelectorAll(".quantity-break");
    _0x10a050.forEach(_0x15525e => {
      const _0x2a3e8f = _0x15525e;
      const _0x31323a = document.querySelector("input[data-input=\"" + _0x2a3e8f.dataset.input + "\"]");
      if (!_0x31323a) {
        return;
      }
      const _0x5538a5 = parseInt(_0x31323a.value);
      const _0x1664d6 = parseFloat(_0x2a3e8f.dataset.percentageLeft || 1);
      const _0x1863c7 = parseInt(_0x2a3e8f.dataset.fixedDiscount || 0);
      const _0x12d840 = this.basePrice;
      const _0x87c3cf = this.baseComparePrice;
      let _0x236657 = Math.round(_0x12d840 * _0x5538a5 * _0x1664d6) - _0x1863c7;
      let _0x5da55a = _0x87c3cf * _0x5538a5;
      let _0x1fc5df = _0x236657;
      let _0xa22904 = _0x5da55a;
      if (this.isSubSelected) {
        const _0x22d147 = this.getSubscriptionPricePerItem();
        _0x1fc5df = Math.round(_0x22d147 * _0x5538a5 * _0x1664d6) - _0x1863c7;
      }
      const _0x35a477 = Math.max(0, _0xa22904 - _0x1fc5df);
      const _0x3d175c = Math.round(_0x35a477 / 100) * 100;
      const _0xe5061d = _0xa22904 > 0 ? Math.floor(_0x35a477 * 100 / _0xa22904) : 0;
      const _0x5cf8a6 = Math.round(_0x1fc5df / _0x5538a5);
      const _0x3f3cae = Math.round(_0xa22904 / _0x5538a5);
      const _0x1f498a = _0x2a3e8f.querySelectorAll(".variant-price-update");
      _0x1f498a.forEach(_0x196e5d => {
        let _0x257609 = _0x196e5d.dataset.text || "";
        _0x257609 = _0x257609.replaceAll("[price]", this.formatMoney(_0x1fc5df, true)).replaceAll("[compare_price]", this.formatMoney(_0xa22904, true)).replaceAll("[amount_saved]", this.formatMoney(_0x35a477, true)).replaceAll("[amount_saved_rounded]", this.formatMoney(_0x3d175c, true)).replaceAll("[percentage_saved]", String(_0xe5061d) + "%").replaceAll("[price_each]", this.formatMoney(_0x5cf8a6, true)).replaceAll("[compare_price_each]", this.formatMoney(_0x3f3cae, true)).replaceAll("[quantity]", String(_0x5538a5));
        _0x196e5d.innerHTML = _0x257609;
        if (_0x196e5d.classList.contains("quantity-break__compare-price")) {
          _0x196e5d.classList.toggle("hidden", !(_0xa22904 > _0x1fc5df));
        }
      });
    });
  }
  handleQuantityChange() {
    if (this.updatePrices) {
      this.updateAllPrices();
    }
  }
  applySubTo(_0x12dbec, _0x2d80a3 = false) {
    if (this.isSubSelected || _0x2d80a3) {
      if (this.discountType === "fixed_amount") {
        return Math.max(0, _0x12dbec - this.discountValue);
      } else if (this.discountType === "percentage") {
        return Math.round(_0x12dbec * (100 - this.discountValue) / 100);
      } else if (this.discountType === "price") {
        return this.discountValue;
      }
    }
    return _0x12dbec;
  }
  updatePdpPrices(_0x5573cb, _0x2787ea) {
    const _0x5abf32 = this.formatMoney(_0x5573cb);
    const _0x44bae1 = this.formatMoney(_0x2787ea);
    const _0x51bf82 = _0x2787ea > _0x5573cb;
    const _0x2f1618 = document.querySelectorAll(".price-" + this.sectionId);
    _0x2f1618.forEach(_0x5587dd => {
      _0x5587dd.classList.toggle("price--on-sale", _0x51bf82);
      const _0x28b62f = _0x5587dd.querySelector(".price__regular .price-item--regular");
      const _0x19b4de = _0x5587dd.querySelector(".price__sale .price-item--sale");
      if (_0x28b62f) {
        _0x28b62f.innerHTML = _0x5abf32;
      }
      if (_0x19b4de) {
        _0x19b4de.innerHTML = _0x5abf32;
      }
      if (_0x51bf82) {
        const _0x3c7423 = _0x5587dd.querySelector(".price__sale .price-item--regular");
        if (_0x3c7423) {
          _0x3c7423.innerHTML = _0x44bae1;
        }
      }
    });
    const _0x28fc72 = document.querySelectorAll(".main-atc-price-span-" + this.sectionId);
    _0x28fc72.forEach(_0x4df859 => {
      _0x4df859.innerHTML = _0x5abf32;
    });
  }
  replacePrice(_0x55eda1, _0x5bc9e1) {
    const _0x215b29 = this.formatMoney(_0x5bc9e1, true);
    return _0x55eda1.replace(/\$[\d,]+\.?\d*/g, _0x215b29);
  }
  updateSubscriptionWidgetPrices() {
    let _0x4dc0be;
    let _0x379536;
    if (this.quantityBreaks) {
      const _0x1d6e47 = this.quantityBreaks.querySelector("input[name=\"quantity\"]:checked");
      if (_0x1d6e47) {
        const _0x33b2d0 = this.quantityBreaks.querySelector("label[data-input=\"" + _0x1d6e47.dataset.input + "\"]");
        if (_0x33b2d0) {
          const _0x1ff73f = parseInt(_0x1d6e47.value);
          const _0x2f7011 = parseFloat(_0x33b2d0.dataset.percentageLeft || 1);
          const _0x5a62fb = parseInt(_0x33b2d0.dataset.fixedDiscount || 0);
          _0x4dc0be = Math.round(this.basePrice * _0x1ff73f * _0x2f7011) - _0x5a62fb;
          _0x379536 = this.baseComparePrice * _0x1ff73f;
        } else {
          _0x4dc0be = this.basePrice;
          _0x379536 = this.baseComparePrice;
        }
      } else {
        _0x4dc0be = this.basePrice;
        _0x379536 = this.baseComparePrice;
      }
    } else {
      _0x4dc0be = this.basePrice;
      _0x379536 = this.baseComparePrice;
    }
    let _0x1471a1;
    if (this.quantityBreaks) {
      const _0x2bf501 = this.quantityBreaks.querySelector("input[name=\"quantity\"]:checked");
      if (_0x2bf501) {
        const _0x2771d9 = this.quantityBreaks.querySelector("label[data-input=\"" + _0x2bf501.dataset.input + "\"]");
        if (_0x2771d9) {
          const _0x52fa90 = parseInt(_0x2bf501.value);
          const _0x338417 = parseFloat(_0x2771d9.dataset.percentageLeft || 1);
          const _0x3bffb6 = parseInt(_0x2771d9.dataset.fixedDiscount || 0);
          const _0x5e3b8c = this.getSubscriptionPricePerItem();
          _0x1471a1 = Math.round(_0x5e3b8c * _0x52fa90 * _0x338417) - _0x3bffb6;
        } else {
          _0x1471a1 = this.getSubscriptionPricePerItem();
        }
      } else {
        _0x1471a1 = this.getSubscriptionPricePerItem();
      }
    } else {
      _0x1471a1 = this.getSubscriptionPricePerItem();
    }
    const _0x586e72 = Math.max(0, _0x379536 - _0x1471a1);
    const _0x143198 = _0x379536 > 0 ? Math.floor(_0x586e72 * 100 / _0x379536) : 0;
    if (this.isToggle) {
      const _0x3e6683 = this.querySelector(".subscription__toggle-option[data-type=\"one_time\"]");
      const _0xd68e59 = this.querySelector(".subscription__toggle-option[data-type=\"subscription\"]");
      if (_0x3e6683 && this.oneTimePriceTemplate) {
        const _0x3fc048 = _0x3e6683.querySelector(".subscription__toggle-label");
        if (_0x3fc048) {
          _0x3fc048.innerHTML = this.replacePrice(this.oneTimePriceTemplate, _0x4dc0be);
        }
      }
      if (_0xd68e59 && this.subPriceTemplate) {
        const _0x5c7c33 = _0xd68e59.querySelector(".subscription__toggle-label");
        if (_0x5c7c33) {
          _0x5c7c33.innerHTML = this.replacePrice(this.subPriceTemplate, _0x1471a1);
        }
      }
    } else {
      if (this.oneTimeBox) {
        const _0x3551aa = this.oneTimeBox.querySelector(".subscription__price");
        if (_0x3551aa && this.oneTimePriceTemplate) {
          _0x3551aa.innerHTML = this.replacePrice(this.oneTimePriceTemplate, _0x4dc0be);
        }
        const _0x25651a = this.oneTimeBox.querySelector(".subscription__compare-price");
        if (_0x25651a && this.oneTimeComparePriceTemplate) {
          if (_0x379536 > _0x4dc0be) {
            _0x25651a.innerHTML = this.replacePrice(this.oneTimeComparePriceTemplate, _0x379536);
            _0x25651a.classList.remove("hidden");
          } else {
            _0x25651a.classList.add("hidden");
          }
        }
      }
      if (this.subscriptionBox) {
        const _0x473508 = this.subscriptionBox.querySelector(".subscription__price");
        if (_0x473508 && this.subPriceTemplate) {
          _0x473508.innerHTML = this.replacePrice(this.subPriceTemplate, _0x1471a1);
        }
        const _0x3d670f = this.subscriptionBox.querySelector(".subscription__compare-price");
        if (_0x3d670f && this.subComparePriceTemplate) {
          if (_0x379536 > _0x1471a1) {
            _0x3d670f.innerHTML = this.replacePrice(this.subComparePriceTemplate, _0x379536);
            _0x3d670f.classList.remove("hidden");
          } else {
            _0x3d670f.classList.add("hidden");
          }
        }
        const _0x5eb939 = this.subscriptionBox.querySelector(".subscription__badge");
        if (_0x5eb939 && this.subBadgeTemplate) {
          let _0x2855a8 = this.subBadgeTemplate;
          _0x2855a8 = _0x2855a8.replace(/\[amount_saved\]/g, this.formatMoney(_0x586e72, true));
          _0x2855a8 = _0x2855a8.replace(/\[percentage_saved\]/g, _0x143198 + "%");
          _0x5eb939.innerHTML = _0x2855a8;
        }
      }
    }
  }
  formatMoney(_0x1f7185, _0x4eef1f = false) {
    if (typeof _0x1f7185 === "string") {
      _0x1f7185 = _0x1f7185.replace(".", "");
    }
    let _0x4c7ff0 = "";
    const _0x113108 = /\{\{\s*(\w+)\s*\}\}/;
    const _0x4c105a = this.moneyFormat;
    function _0xe8609e(_0x1b1e98, _0x157dd1) {
      if (typeof _0x1b1e98 === "undefined") {
        return _0x157dd1;
      } else {
        return _0x1b1e98;
      }
    }
    function _0xef2e62(_0x49d0e5, _0x1594c5, _0x465f16, _0x35eabb) {
      _0x1594c5 = _0xe8609e(_0x1594c5, 2);
      _0x465f16 = _0xe8609e(_0x465f16, ",");
      _0x35eabb = _0xe8609e(_0x35eabb, ".");
      if (isNaN(_0x49d0e5) || _0x49d0e5 == null) {
        return 0;
      }
      _0x49d0e5 = (_0x49d0e5 / 100).toFixed(_0x1594c5);
      const _0xbc3fc6 = _0x49d0e5.split(".");
      const _0xf97a26 = _0xbc3fc6[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + _0x465f16);
      const _0x264e1e = _0xbc3fc6[1] ? _0x35eabb + _0xbc3fc6[1] : "";
      if (_0x4eef1f && _0x264e1e === _0x35eabb + "00") {
        return _0xf97a26;
      }
      return _0xf97a26 + _0x264e1e;
    }
    switch (_0x4c105a.match(_0x113108)[1]) {
      case "amount":
        _0x4c7ff0 = _0xef2e62(_0x1f7185, 2);
        break;
      case "amount_no_decimals":
        _0x4c7ff0 = _0xef2e62(_0x1f7185, 0);
        break;
      case "amount_with_comma_separator":
        _0x4c7ff0 = _0xef2e62(_0x1f7185, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        _0x4c7ff0 = _0xef2e62(_0x1f7185, 0, ".", ",");
        break;
    }
    return _0x4c105a.replace(_0x113108, _0x4c7ff0);
  }
}
customElements.define("theme-subscription-widget", ThemeSubscriptionWidget);
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.secondarySelectSelector = "StickyAtcVariantPicker-";
    this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section);
    this.isSecondary = false;
    this.QuantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
    this.hasQuantityBreaksPicker = this.dataset.hasQuantityBreaksPicker === "true";
    this.prependMedia = this.dataset.disablePrepend != "true";
    this.filtering = this.dataset.hasFiltering === "true";
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    if (this.hasQuantityBreaksPicker) {
      this.quantityBreaksPickerStyle = this.dataset.quantityBreaksPickerStyle;
      this.quantityBreaksPickerDisplayedImages = this.dataset.quantityBreaksPickerDisplayedImages;
    }
    this.addEventListener("change", this.onVariantChange);
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      if (this.skipNonExistent && findAvailableVariant(this, this.options, true, true, this.skipUnavailable)) {
        return;
      }
      this.setUnavailable();
    } else {
      if (this.skipUnavailable && !this.currentVariant.available) {
        if (findAvailableVariant(this, this.options, true, true, true)) {
          return;
        }
      }
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }
  updateOptions() {
    const _0x3c4e52 = [];
    this.querySelectorAll(".product-form__input").forEach(_0x194c00 => {
      let _0x3ac0b8;
      const _0x54fa02 = _0x194c00.querySelector(".product-form__input__type").dataset.type;
      if (_0x54fa02 == "dropdown" || _0x54fa02 == "dropdwon") {
        _0x3ac0b8 = _0x194c00.querySelector(".select__select").value;
      } else {
        _0x3ac0b8 = _0x194c00.querySelector("input[type=\"radio\"]:checked").value;
      }
      _0x3c4e52.push(_0x3ac0b8);
    });
    this.options = _0x3c4e52;
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(_0x1103d2 => {
      return !_0x1103d2.options.map((_0x423a67, _0x13bb90) => {
        return this.options[_0x13bb90] === _0x423a67;
      }).includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant) {
      return;
    }
    if (!this.currentVariant.featured_media) {
      return;
    }
    const _0x16a202 = document.querySelectorAll("[id^=\"MediaGallery-" + this.dataset.section + "\"]");
    _0x16a202.forEach(_0x75e2b4 => _0x75e2b4.setActiveMedia(this.dataset.section + "-" + this.currentVariant.featured_media.id, this.prependMedia, this.filtering, this.currentVariant));
    const _0x5b4f51 = document.querySelector("#ProductModal-" + this.dataset.section + " .product-media-modal__content");
    if (!_0x5b4f51) {
      return;
    }
    const _0x29393e = _0x5b4f51.querySelector("[data-media-id=\"" + this.currentVariant.featured_media.id + "\"]");
    _0x5b4f51.prepend(_0x29393e);
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") {
      return;
    }
    window.history.replaceState({}, "", this.dataset.url + "?variant=" + this.currentVariant.id);
  }
  updateShareUrl() {
    const _0x526a1b = document.getElementById("Share-" + this.dataset.section);
    if (!_0x526a1b || !_0x526a1b.updateUrl) {
      return;
    }
    _0x526a1b.updateUrl("" + window.shopUrl + this.dataset.url + "?variant=" + this.currentVariant.id);
  }
  updateVariantInput() {
    const _0x15fece = document.querySelectorAll("#product-form-" + this.dataset.section + ", #product-form-installment-" + this.dataset.section);
    _0x15fece.forEach(_0x1f4177 => {
      const _0x579c3e = _0x1f4177.querySelector("input[name=\"id\"]");
      _0x579c3e.value = this.currentVariant.id;
      _0x579c3e.dispatchEvent(new Event("change", {
        bubbles: true
      }));
    });
  }
  updateVariantStatuses() {
    const _0x275251 = this.variantData.filter(_0x37f49d => this.querySelector(":checked").value === _0x37f49d.option1);
    let _0x2a493e;
    if (this.isSecondary && this.secondarySelect) {
      _0x2a493e = [...this.secondarySelect.querySelectorAll(".product-form__input")];
    } else {
      _0x2a493e = [...this.querySelectorAll(".product-form__input")];
    }
    _0x2a493e.forEach((_0x4b778e, _0x277388) => {
      if (_0x277388 === 0) {
        return;
      }
      const _0x214c80 = [..._0x4b778e.querySelectorAll("input[type=\"radio\"], .select__select option")];
      const _0x3eb317 = _0x2a493e[_0x277388 - 1].querySelector(":checked").value;
      const _0x3896d7 = _0x275251.filter(_0x4245ee => _0x4245ee.available && _0x4245ee["option" + _0x277388] === _0x3eb317).map(_0x1ed946 => _0x1ed946["option" + (_0x277388 + 1)]);
      const _0x22ca55 = _0x275251.filter(_0x37b3f7 => _0x37b3f7["option" + _0x277388] === _0x3eb317).map(_0x3a8180 => _0x3a8180["option" + (_0x277388 + 1)]);
      this.setInputAvailability(_0x214c80, _0x3896d7, _0x22ca55);
    });
  }
  setInputAvailability(_0x5bdffd, _0x2eb5a6, _0x4a88f6) {
    _0x5bdffd.forEach(_0x2c6269 => {
      _0x2c6269.classList.remove("unavailable", "non-existent", "disabled");
      const _0x35a115 = _0x2c6269.getAttribute("value");
      let _0x544d91 = null;
      if (_0x2c6269.dataset.swatch === "true") {
        _0x544d91 = _0x2c6269.closest(".color-swatch");
      }
      if (_0x544d91) {
        _0x544d91.classList.remove("unavailable", "non-existent", "disabled");
      }
      if (_0x4a88f6.includes(_0x35a115)) {
        if (_0x2eb5a6.includes(_0x35a115)) {
          if (_0x2c6269.nodeName === "OPTION") {
            _0x2c6269.innerText = _0x35a115;
          } else {
            _0x2c6269.classList.remove("disabled");
            if (_0x544d91) {
              _0x544d91.classList.remove("disabled");
            }
          }
        } else if (_0x2c6269.nodeName === "OPTION") {
          _0x2c6269.innerText = window.variantStrings.unavailable_with_option.replace("[value]", _0x35a115);
          _0x2c6269.classList.add("unavailable");
        } else {
          _0x2c6269.classList.add("disabled", "unavailable");
          if (_0x544d91) {
            _0x544d91.classList.add("disabled", "unavailable");
          }
        }
      } else if (_0x2c6269.nodeName === "OPTION") {
        _0x2c6269.innerText = window.variantStrings.unavailable_with_option.replace("[value]", _0x35a115);
        _0x2c6269.classList.add("non-existent");
      } else {
        _0x2c6269.classList.add("disabled", "non-existent");
        if (_0x544d91) {
          _0x544d91.classList.add("disabled", "non-existent");
        }
      }
    });
  }
  updatePickupAvailability() {
    const _0x2bff01 = document.querySelector("pickup-availability");
    if (!_0x2bff01) {
      return;
    }
    if (this.currentVariant && this.currentVariant.available) {
      if (_0x2bff01.fetchAvailability) {
        _0x2bff01.fetchAvailability(this.currentVariant.id);
      }
    } else {
      _0x2bff01.removeAttribute("available");
      _0x2bff01.innerHTML = "";
    }
  }
  removeErrorMessage() {
    const _0x1deae7 = this.closest("section");
    if (!_0x1deae7) {
      return;
    }
    const _0x5ea69c = _0x1deae7.querySelector("product-form");
    if (_0x5ea69c) {
      _0x5ea69c.handleErrorMessage();
    }
  }
  renderProductInfo() {
    const _0x3bbc75 = this.currentVariant.id;
    const _0x564dad = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    fetch(this.dataset.url + "?variant=" + _0x3bbc75 + "&section_id=" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)).then(_0xc4665 => _0xc4665.text()).then(_0xe36ce7 => {
      if (this.currentVariant.id !== _0x3bbc75) {
        return;
      }
      const _0x423eea = new DOMParser().parseFromString(_0xe36ce7, "text/html");
      const _0x5c7699 = document.getElementById("price-" + this.dataset.section);
      const _0x391c2c = _0x423eea.getElementById("price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const _0x1799cd = document.getElementById("sticky-atc-separate-price-" + this.dataset.section);
      const _0x4e7779 = _0x423eea.getElementById("sticky-atc-separate-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const _0x5d3f8d = document.getElementById("sticky-atc-price-" + this.dataset.section);
      const _0x5d4fb5 = _0x423eea.getElementById("sticky-atc-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const _0x3e99f7 = document.getElementById("sticky-atc-image-" + this.dataset.section);
      const _0x470be3 = _0x423eea.getElementById("sticky-atc-image-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const _0x5325ba = document.getElementById("main-atc-price-" + this.dataset.section);
      const _0x18e3df = _0x423eea.getElementById("main-atc-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const _0x38b3b4 = document.querySelectorAll("[id^=\"custom-label-" + this.dataset.section + "\"]");
      const _0x5a4eb1 = _0x423eea.querySelectorAll("[id^=\"custom-label-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section) + "\"]");
      const _0x4e4842 = _0x423eea.getElementById("Sku-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const _0x26c744 = document.getElementById("Sku-" + this.dataset.section);
      const _0x4cfc12 = _0x423eea.getElementById("Inventory-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const _0x5a6dfd = document.getElementById("Inventory-" + this.dataset.section);
      if (_0x5c7699 && _0x391c2c) {
        _0x5c7699.innerHTML = _0x391c2c.innerHTML;
      }
      if (_0x1799cd && _0x4e7779) {
        _0x1799cd.innerHTML = _0x4e7779.innerHTML;
      }
      if (_0x5d3f8d && _0x5d4fb5) {
        _0x5d3f8d.innerHTML = _0x5d4fb5.innerHTML;
      }
      if (_0x3e99f7 && _0x470be3) {
        _0x3e99f7.src = _0x470be3.src;
      }
      if (_0x18e3df && _0x5325ba) {
        _0x5325ba.innerHTML = _0x18e3df.innerHTML;
      }
      if (_0x38b3b4 && _0x5a4eb1) {
        for (var _0x203234 = 0; _0x203234 < _0x38b3b4.length; _0x203234++) {
          _0x38b3b4[_0x203234].innerHTML = _0x5a4eb1[_0x203234].innerHTML;
        }
      }
      if (_0x4cfc12 && _0x5a6dfd) {
        _0x5a6dfd.innerHTML = _0x4cfc12.innerHTML;
      }
      if (_0x4e4842 && _0x26c744) {
        _0x26c744.innerHTML = _0x4e4842.innerHTML;
        _0x26c744.classList.toggle("visibility-hidden", _0x4e4842.classList.contains("visibility-hidden"));
      }
      if (this.QuantityBreaks) {
        const _0x5aca87 = _0x423eea.getElementById("quantity-breaks-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
        const _0x51af29 = this.QuantityBreaks.querySelectorAll(".dynamic-price");
        const _0x190ba3 = _0x5aca87.querySelectorAll(".dynamic-price");
        for (let _0x1c0789 = 0; _0x1c0789 < _0x51af29.length; _0x1c0789++) {
          _0x51af29[_0x1c0789].innerHTML = _0x190ba3[_0x1c0789].innerHTML;
        }
        if (this.QuantityBreaks.hasVariants) {
          this.QuantityBreaks.variantSelects.forEach(_0x44485d => {
            _0x44485d.dataset.selectedId = this.currentVariant.id;
          });
          const _0x710bed = this.QuantityBreaks.querySelectorAll(".quantity-break__variant-select");
          const _0x3439ae = _0x5aca87.querySelectorAll(".quantity-break__variant-select");
          for (let _0x12cf60 = 0; _0x12cf60 < _0x710bed.length; _0x12cf60++) {
            _0x710bed[_0x12cf60].innerHTML = _0x3439ae[_0x12cf60].innerHTML;
          }
          this.QuantityBreaks.initVariants();
        }
        ;
      }
      if (this.hasQuantityBreaksPicker) {
        const _0x2348ff = _0x423eea.getElementById("variant-selects-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
        const _0x277372 = this.querySelectorAll(".dynamic-price");
        const _0x5f43bd = _0x2348ff.querySelectorAll(".dynamic-price");
        for (let _0x434ec7 = 0; _0x434ec7 < _0x277372.length; _0x434ec7++) {
          _0x277372[_0x434ec7].innerHTML = _0x5f43bd[_0x434ec7].innerHTML;
        }
        if (this.quantityBreaksPickerStyle === "vertical" && this.quantityBreaksPickerDisplayedImages === "variant_images") {
          const _0x38971b = this.querySelectorAll(".quantity-break__image img");
          const _0x417a65 = _0x2348ff.querySelectorAll(".quantity-break__image img");
          for (let _0x4c473a = 0; _0x4c473a < _0x38971b.length; _0x4c473a++) {
            _0x38971b[_0x4c473a].src = _0x417a65[_0x4c473a].src;
          }
        }
      }
      if (this.secondarySelect) {
        const _0x5398c2 = _0x423eea.getElementById("" + this.secondarySelectSelector + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
        if (_0x5398c2) {
          this.secondarySelect.innerHTML = _0x5398c2.innerHTML;
        }
      }
      const _0x380ec8 = document.getElementById("price-" + this.dataset.section);
      if (_0x380ec8) {
        _0x380ec8.classList.remove("visibility-hidden");
      }
      this.dataset.options = this.currentVariant.options.join(",");
      if (_0x5a6dfd) {
        _0x5a6dfd.classList.toggle("visibility-hidden", _0x4cfc12.innerText === "");
      }
      const _0x6504c5 = _0x423eea.getElementById("ProductSubmitButton-" + _0x564dad);
      this.toggleAddButton(_0x6504c5 ? _0x6504c5.hasAttribute("disabled") : true, window.variantStrings.soldOut);
      const _0x157c4e = {
        sectionId: _0x564dad,
        html: _0x423eea,
        variant: this.currentVariant
      };
      const _0x549c55 = _0x157c4e;
      const _0xbf307a = _0x549c55;
      const _0x342d20 = {
        data: _0xbf307a
      };
      const _0x58cc6b = _0x342d20;
      const _0x332d4b = _0x58cc6b;
      publish(PUB_SUB_EVENTS.variantChange, _0x332d4b);
    });
  }
  toggleAddButton(_0x158b33 = true, _0x10d392, _0x4702dc = true) {
    const _0x4d0f10 = document.getElementById("product-form-" + this.dataset.section);
    if (!_0x4d0f10) {
      return;
    }
    const _0x56021f = _0x4d0f10.querySelector("[name=\"add\"]");
    const _0x124354 = document.querySelectorAll(".main-product-atc");
    var _0x491356 = _0x4d0f10.querySelector(".main-atc__label__text");
    if (!_0x491356) {
      _0x491356 = _0x4d0f10.querySelector(".main-atc__label");
    }
    const _0x5115f8 = _0x4d0f10.querySelector(".main-atc-price");
    if (!_0x56021f) {
      return;
    }
    if (_0x158b33) {
      _0x56021f.setAttribute("disabled", "disabled");
      _0x56021f.setAttribute("data-unavailable", "true");
      if (_0x10d392) {
        _0x491356.textContent = _0x10d392;
      }
      _0x124354.forEach(_0x9990bd => {
        _0x9990bd.setAttribute("disabled", "disabled");
      });
      if (_0x5115f8) {
        _0x5115f8.classList.add("hidden");
      }
    } else {
      _0x56021f.setAttribute("data-unavailable", "false");
      _0x491356.textContent = window.variantStrings.addToCart;
      if (_0x5115f8) {
        _0x5115f8.classList.remove("hidden");
      }
      if (_0x56021f.dataset.requiredFields === _0x56021f.dataset.validFields) {
        _0x56021f.removeAttribute("disabled");
        _0x124354.forEach(_0x15ff6e => {
          _0x15ff6e.removeAttribute("disabled");
        });
      }
    }
    if (!_0x4702dc) {
      return;
    }
  }
  setUnavailable() {
    const _0x35c516 = document.getElementById("product-form-" + this.dataset.section);
    if (!_0x35c516) {
      return;
    }
    const _0x2e6337 = _0x35c516.querySelector("[name=\"add\"]");
    var _0x432f2a = _0x35c516.querySelector(".main-atc__label__text");
    if (!_0x432f2a) {
      _0x432f2a = _0x35c516.querySelector(".main-atc__label");
    }
    const _0x359555 = document.getElementById("price-" + this.dataset.section);
    const _0xa53729 = document.getElementById("Inventory-" + this.dataset.section);
    const _0x284170 = document.getElementById("Sku-" + this.dataset.section);
    if (!_0x2e6337) {
      return;
    }
    _0x432f2a.textContent = window.variantStrings.unavailable;
    if (_0x359555) {
      _0x359555.classList.add("visibility-hidden");
    }
    if (_0xa53729) {
      _0xa53729.classList.add("visibility-hidden");
    }
    if (_0x284170) {
      _0x284170.classList.add("visibility-hidden");
    }
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector("[type=\"application/json\"]").textContent);
    return this.variantData;
  }
}
customElements.define("variant-selects", VariantSelects);
class SecondaryVariantSelect extends VariantSelects {
  constructor() {
    super();
    this.secondarySelectSelector = "variant-selects-";
    this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section);
    this.isSecondary = true;
  }
  updateOptions() {
    this.options = this.querySelector("select").value.split(",");
  }
}
customElements.define("secondary-variant-select", SecondaryVariantSelect);
class SecondaryVariantSelectSeparate extends VariantSelects {
  constructor() {
    super();
    this.secondarySelectSelector = "variant-selects-";
    this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section);
    this.isSecondary = true;
  }
}
customElements.define("secondary-variant-select-separate", SecondaryVariantSelectSeparate);
class CardVariantSelects extends VariantSelects {
  constructor() {
    super();
    this.quickAddSubmit = document.getElementById(this.dataset.section + "-submit");
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateVariantInput();
      this.updateQuickAddUrl();
      this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
    }
  }
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) {
      return;
    }
    const _0x33f582 = document.getElementById(this.dataset.section + "-image");
    if (!_0x33f582) {
      return;
    }
    const _0x37a37c = this.currentVariant.featured_media.preview_image;
    const _0x5c96bd = _0x37a37c.src.split("?")[0];
    const _0x5a8f7e = [165, 360, 533, 720, 940, 1066];
    const _0x1d909c = _0x5a8f7e.filter(_0x116185 => _0x37a37c.width >= _0x116185).map(_0x5a7ad8 => _0x5c96bd + "?width=" + _0x5a7ad8 + " " + _0x5a7ad8 + "w").join(", ");
    _0x33f582.srcset = _0x1d909c + ", " + _0x5c96bd + " " + _0x37a37c.width + "w";
    _0x33f582.src = _0x5c96bd + "?width=533";
  }
  updateQuickAddUrl() {
    if (!this.currentVariant || !this.quickAddSubmit) {
      return;
    }
    this.quickAddSubmit.dataset.productUrl = this.dataset.url + "?variant=" + this.currentVariant.id;
  }
}
customElements.define("card-variant-selects", CardVariantSelects);